import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";

// import translationEN from '../public/locales/en/translation.json';

// the translations
const resources = {
  en: {
    translation: {
      //Generales
      "Confirmar": "Confirm",
      //Menu
      "Log in": "Login",
      "Exit": "Exit",
      "TAQUILLA": "LOCKER",
      "RESUMEN": "SUMMARY",
      "Mapa": "Map",
      //Step Bar
      "Zona": "Zone",
      "Taquilla": "Locker",
      "Pago": "Pay",
      "Email": "Email",
      //Home View
      "PARECE QUE ALGO HA FALLADO": "IT SEEMS SOMETHING HAS FAILED",
      "VUELVE A ESCANEAR EL QR": "SCAN THE QR AGAIN",
      //Zone Selector View
      "SELECCIONA LA ZONA DE TAQUILLAS": "SELECT THE LOCKERS ZONE",
      "BIENVENIDO A": "WELCOME TO",
      "CONSULTA EL MAPA DEL PARQUE": "CHECK THE MAP OF THE PARK",
      "ZONA ": "ZONE ",
      //Locker Selector View
      "SELECCIONA EL TIPO DE TAQUILLA": "SELECT THE TYPE OF LOCKER",
      "PARQUE": "PARK",
      "ZONA SELECCIONADA": "ZONE SELECTED",
      "Taquilla": "Locker",
      "BÁSICA": "STANDARD",
      "BÁSICA CARGA": "STANDARD CHARGER",
      "BÁSICA XL": "STANDARD XL",
      "BÁSICA CARGA XL": "STANDARD CHARGER XL",
      "GRANDE": "BIG",
      "GRANDE CARGA": "BIG CHARGER",
      "GRANDE XL": "BIG XL",
      "GRANDE CARGA XL": "BIG CHARGER XL",
      "SKI": "SKI",
      "SKI CARGA": "SKI CHARGER",
      "SKI XL": "SKI XL",
      "SKI CARGA XL": "SKI CHARGER XL",
      "TAQUILLAS AGOTADAS": "SOLD OUT LOCKERS",
      "Haz click aquí para volver a selección de zonas": "Click here to return to zone selection",
      //Accessibility View
      "¿NECESITAS UNA TAQUILLA ADAPTADA?": "DO YOU NEED AN ADAPTED LOCKER?",
      "Tienes la opción de seleccionar una taquilla de altura adaptada para tu confort.": "You have the option of selecting a height adapted locker for your comfort.",
      "NO": "NO",
      "SI": "YES",
      //Payment View
      "CONFIRMA TU COMPRA": "VERIFY YOUR ORDER",
      "Taquilla reservada durante": "Reserved locker during",
      "PARQUE": "PARK",
      "ZONA": "ZONE",
      "ACCESIBLE": "ACCESSIBLE",
      "RESERVA": "RESERVATION",
      "TIPO DE TAQUILLA": "LOCKER TYPE",
      "HASTA FINALIZAR EL DÍA": "UNTIL THE END OF THE DAY",
      "IVA": "VAT",
      "IMPORTE BASE": "BASE AMOUNT",
      "IMPORTE IVA": "VAT AMOUNT",
      "TOTAL": "TOTAL",
      "Tiempo de reserva agotado": "Reservation time out",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo, otros usuarios deben poder acceder a ella. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "We are sorry, but we cannot reserve your locker for longer, other users must be able to access it. Start the process again and complete the purchase within the stipulated time.",
      "Volver al inicio": "Back to start",
      "¿Seguro que quieres salir?": "Are you sure you want to leave?",
      "Si abandonas ahora, tu taquilla reservada quedará libre y otro usuario podrá alquilarla.": "If you leave now, your reserved locker will be released and another user may rent it.",
      "Continuar con el alquiler": "Continue with rental",
      "Cancelar y salir": "Cancel and leave",
      "¿Volver a editar tus datos?": "Edit your details?",
      "Tu taquilla permanecerá reservada mientras completas el formulario.": "Your locker will remain reserved while you complete the form.",
      "Quedarme aquí": "Stay here",
      "PAGAR": "PAY",
      "RESERVAR": "RENT",
      //Payment Error View
      "ERROR": "ERROR",
      "No se ha podido realizar la compra. Vuelve a intentarlo más tarde.": "The purchase could not be made. Try again later.",
      "VOLVER": "RETURN TO",
      "AL INICIO": "START",
      //Phone View
      "¡TU TAQUILLA HA SIDO RESERVADA!": "YOUR LOCKER HAS BEEN RESERVED!",
      "FACILITANOS TUS DATOS DE RESPALDO": "PROVIDE US WITH YOUR BACKUP DATA",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin de esta en caso de que lo pierdas. Al email te llegará la confirmación de tu reserva.": "Your phone will be linked to the reserved locker to be able to recover its Pin in case you lose it. You will receive confirmation of your reservation by email.",
      "TELÉFONO*": "PHONE NUMBER*",
      "EMAIL*": "EMAIL*",
      "Acepto ceder mi correo electrónico para recibir la confirmación de mi reserva.": "I agree to give my email to receive confirmation of my reservation.",
      "Acepto suscribirme al boletín informativo de VACWAY para recibir contenido y notificaciones comerciales.": "I agree to subscribe to the VACWAY newsletter to receive commercial content and notifications.",
      "CONTINUAR": "CONTINUE",
      "*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.": "*The personal data collected will not be used in any case to offer commercial communications of any kind if the client does not subscribe to the newsletter.",
      //Ticket View
      "¡GRACIAS POR RESERVAR TU TAQUILLA!": "THANK YOU FOR RESERVING YOUR LOCKER!",
      "Sigue las instrucciones que encontrarás a continuación o en tu email.": "Follow the instructions that you will find below or in your email.",
      "TICKET": "TICKET",
      "Nº TAQUILLA": "LOCKER No.",
      "PIN": "PIN",
      "ZONA": "ZONE",
      "TIPO": "TYPE",
      "UBICACIÓN": "LOCATION",
      "FACTURA": "INVOICE",
      "*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva.": "*If you want to obtain the Pin in physical format to carry it during your stay in the park, contact the people in charge of the ticket office area and show them your reservation email.",
      "Proceso completado, taquilla reservada.": "Process complete, locker reserved.",
      "Alquilar otra taquilla": "Rent another locker",
      "DESCARGAR TICKET": "DOWNLOAD TICKET",
      "INSTRUCCIONES": "INSTRUCTIONS",
      "PASO 1": "STEP 1",
      "LOCALIZA TU TAQUILLA": "LOCATE YOUR LOCKER",
      "PASO 2": "STEP 2",
      "TOCA EL TECLADO": "TOUCH THE KEYBOARD",
      "PASO 3": "STEP 3",
      "INTRODUCE TU PIN": "INSERT YOUR PIN",
      "PASO 4": "STEP 4",
      "ABRE LAS VECES QUE QUIERAS": "OPEN AS MANY TIMES AS YOU WANT",
      "ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS": "OPEN 1 TIME TO STORE YOUR THINGS, ONCE YOU CLOSE YOU HAVE 1 MORE OPENING TO TAKE THEM OUT",
      //Ticket in Pdf (Ticket View)
      "Más información y garantía en www.vacway.com": "More information and warranty at www.vacway.com",
      "Factura Simplificada": "Simplified invoice",
      "INFORMACIÓN DE TU LOCKER:": "YOUR LOCKER INFORMATION:",
      "Producto": "Product",
      "UNIDADES": "Units",
      "Fecha y Hora": "Date and Time",
      "Reserva": "Rental",
      //LockerSelectorBaqueiraView
      "2 Equipos de esquí": "2 Ski sets",
      "3 Equipos de esquí": "3 Ski sets",
      "4 Equipos de esquí": "4 Ski sets",
      "Selecciona...": "Select...",
      "Taquillas": "Lockers",
      "Atrás": "Back",
      "Continuar": "Next",
      "Fecha de Inicio": "Start Date",
      "Fecha de Fin": "End Date",
      "LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.": "SORRY, THESE DATES ARE NOT AVAILABLE. TRY OTHER DATES OR ANOTHER TYPE OF LOCKER.",
      "ZONA": "ZONE",
      "TIPO": "TYPE",
      "CANTIDAD": "QUANTITY",
      "FECHAS": "DATES",
      "Selecciona el tipo de taquilla": "Select the type of locker",
      "Selecciona la cantidad": "Select the quantity",
      "Selecciona las fechas": "Select the dates",
      "REVISA Y CONFIRMA": "REVIEW AND CONFIRM",
      "El día actual no está disponible para selección después de las 18:00 hora local.": "The current day is not available for selection after 18:00 local time.",
      "El alquiler online está limitado a 14 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es": "Online rentals are limited to 14 consecutive days, for long-term reservations please contact the Baqueira Store staff or request it via email at skiservice@baqueira.es.",
      "Zona": "Zone",
      "Tipo": "Type",
      "Cantidad": "Quantity",
      "Fechas": "Dates",
      "Importe": "Amount",
      "taquilla": "Locker",
      "taquillas": "Lockers",
      "Inicio": "Start",
      "Fin": "End",
      "DD/MM/YYYY": "DD/MM/YYYY",
      "Descuento aplicado": "Discount applied: {{discount}}% (from {{days}} days)",
      "Lun": "Mon",
      "Mar": "Tue",
      "Mie": "Wed",
      "Jue": "Thu",
      "Vie": "Fri",
      "Sab": "Sat",
      "Dom": "Sun",
      //PhoneBaqueiraView
      "NOMBRE COMPLETO*": "COMPLETE NAME*",
      "Confirmo que he leído y acepto los términos y condiciones de uso del servicio.": "I confirm that I have read and accept the terms and conditions of use of the service.",
      "Leer términos y condiciones.": "Read terms and conditions.",
      //TicketBaqueiraView
      "Disponible en tu email que se enviará el día de inicio de tu reserva": "Available in your email, which will be sent on the start date of your reservation",
      "FECHA COMPRA": "PURCHASE DATE",
      //PaymentBaqueiraView
      "Te hemos aplicado un descuento en el precio, solo vas a pagar 5 días de tu reserva!": "We have applied a discount to the price; you will only pay for 5 days of your reservation!",
      "IMPORTE ORIGINAL": "ORIGINAL AMOUNT",
      "Lo sentimos, pero la venta no está disponible entre las 23:00h y la 01:00h, vuelva fuera de este horario.": "We are sorry, but sales are not available between 11:00 PM and 01:00 AM, please return outside this time frame.",
      "Fuera de horario": "Outside of hours",
      //PRERENTAL
      " por ": " ",
      "RESERVA DE TAQUILLAS": "LOCKER RESERVATION",
      "Cantidad de taquillas": "Number of lockers",
      "Selecciona cuántas taquillas necesitas": "Select how many lockers you need",
      "taquillas seleccionadas": "lockers selected",
      "taquilla seleccionada": "locker selected",
      "RESERVA DE TAQUILLA": "LOCKER RESERVATION",
      "Nombre Completo*": "Full Name*",
      "Email*": "Email*",
      "Teléfono*": "Phone*",
      "Confirmo que he leído y acepto los": "I confirm that I have read and accept the",
      "términos y condiciones": "terms and conditions",
      "CONFIRMA TU COMPRA": "CONFIRM YOUR PURCHASE",
      "Tiempo para confirmar": "Time to confirm",
      "Revisa los datos de tu reserva": "Check your reservation details",
      "Zona:": "Zone:",
      "Inicio:": "Start:",
      "Nombre": "Name",
      "Taquilla": "Locker",
      "Fin": "End",
      "Cantidad": "Quantity",
      "Hora Límite": "Deadline",
      "Teléfono": "Phone",
      "Confirma los importes": "Confirm payment details",
      "Base": "Subtotal",
      "Pagar": "Pay",
      "IVA": "TAX",
      "Revisa los datos antes de confirmar el pago": "Review your details before confirming payment",
      "¿Necesitas hacer algún cambio?": "Need to make any changes?",
      "Editar mis datos": "Edit my details",
      "Cambiar taquilla": "Change locker",
      "Cancelar reserva": "Cancel reservation",
      "Resumen de reserva": "Booking summary",
      "Código de reserva": "Booking code",
      "Información de taquilla": "Locker information",
      "Instrucciones": "Instructions",
      "DATOS DE RESPALDO": "BACKUP INFORMATION",
      "Reservar": "Book Now",
      "Rellena los datos para ver disponibilidad": "Fill in the details to check availability",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin": "Your phone will be linked to the reserved locker so you can recover the Pin",
      "Confirmar Email*": "Confirm Email*",
      "Repite tu email": "Repeat your email",
      "Los emails no coinciden": "Emails do not match",
      "Tiempo para completar": "Time to complete",
      "Introduce tu email": "Enter your email",
      "Introduce tu teléfono": "Enter your phone number",
      "Documento de Identidad*": "Identity Document*",
      "DNI / NIE / Pasaporte": "ID / NIE / Passport",
      //Locker Info Modal
      "Volver": "Back",
      "¿Qué cabe en esta taquilla?": "What fits in this locker?",
      "Ancho": "Width",
      "Alto": "Height",
      "Fondo": "Depth",
      "Ver información": "View information",
      "Artículos compactos y anchos": "Wide compact items",
      "Artículos pequeños": "Small items",
      "Mochila urbana grande": "Large city backpack",
      "Mochila urbana": "City backpack",
      "Maleta de cabina y mochilas grandes": "Cabin luggage & large backpacks",
      "Mochilas grandes y deporte": "Large backpacks & sports",
      "Maleta mediana": "Medium suitcase",
      "Equipaje alto y estrecho": "Tall narrow luggage",
      "Maleta grande de facturación": "Large checked luggage",
      "Maleta alta y deporte": "Tall luggage & sports",
      "Equipaje extra grande": "Extra large luggage",
      "Perfecta para cascos de bici o moto, bolsos de mano anchos y artículos personales voluminosos.": "Perfect for bike or motorbike helmets, wide handbags and bulky personal items.",
      "Ideal para cascos de bicicleta, bolsos pequeños y artículos personales de bolsillo.": "Ideal for bicycle helmets, small bags and pocket personal items.",
      "Cabe una mochila de ciudad amplia, bolsa de la compra o bolso de hombro de gran tamaño.": "Fits a large city backpack, shopping bag or large shoulder bag.",
      "Perfecta para mochila de portátil, bolsa de tela o chaqueta doblada.": "Perfect for a laptop backpack, tote bag or folded jacket.",
      "Admite mochilas de gran tamaño y maletas de cabina estándar (hasta 55 cm de alto, 40 cm de ancho).": "Fits large backpacks and standard cabin luggage (up to 55 cm tall, 40 cm wide).",
      "Caben mochilas de trekking, bolsas de deporte y equipo de montaña.": "Fits trekking backpacks, sports bags and mountain gear.",
      "Perfecta para maletas medianas de cabina y bolsas de deporte de gran tamaño.": "Perfect for medium cabin suitcases and large sports bags.",
      "Indicada para maletas delgadas en posición vertical o bolsas de esquí estrechas.": "Suitable for slim upright suitcases or narrow ski bags.",
      "Para maletas grandes de facturación y equipos deportivos voluminosos.": "For large checked suitcases and bulky sports equipment.",
      "Para maletas altas y estrechas, bolsas de viaje largas o estuches de instrumentos.": "For tall narrow suitcases, long travel bags or instrument cases.",
      "Nuestra taquilla más grande. Admite maletas enormes, tablas de surf, bolsas de ski o bicicletas plegadas.": "Our largest locker. Fits huge suitcases, surfboards, ski bags or folded bikes.",
      "Para equipos de gran formato: esquís, tablas largas, instrumentos o maletas extra altas.": "For oversized equipment: skis, long boards, instruments or extra-tall suitcases.",
      "🪖 Casco bici / moto": "🪖 Bike / motorbike helmet",
      "👜 Bolso de mano": "👜 Handbag",
      "📦 Artículos pequeños": "📦 Small items",
      "🪖 Casco bicicleta": "🪖 Bicycle helmet",
      "👜 Bolso pequeño": "👜 Small bag",
      "🎒 Mochila mini": "🎒 Mini backpack",
      "🎒 Mochila urbana": "🎒 City backpack",
      "🛍️ Bolsa de compras": "🛍️ Shopping bag",
      "👜 Bolso grande": "👜 Large bag",
      "🎒 Mochila portátil": "🎒 Laptop backpack",
      "🧥 Chaqueta": "🧥 Jacket",
      "🛍️ Bolsa de tela": "🛍️ Tote bag",
      "🧳 Maleta cabina": "🧳 Cabin suitcase",
      "🎒 Mochila grande": "🎒 Large backpack",
      "⛷️ Botas de esquí": "⛷️ Ski boots",
      "🎒 Mochila trekking": "🎒 Trekking backpack",
      "🏋️ Bolsa de deporte": "🏋️ Sports bag",
      "🏕️ Equipo montaña": "🏕️ Mountain gear",
      "🧳 Maleta mediana": "🧳 Medium suitcase",
      "🏋️ Bolsa deporte XL": "🏋️ XL sports bag",
      "🎿 Bolsa de esquí": "🎿 Ski bag",
      "🧳 Maleta delgada": "🧳 Slim suitcase",
      "🎿 Esquís": "🎿 Skis",
      "🏄 Tabla estrecha": "🏄 Narrow board",
      "🧳 Maleta grande": "🧳 Large suitcase",
      "🎿 Equipo esquí": "🎿 Ski equipment",
      "🛹 Skateboard": "🛹 Skateboard",
      "🧳 Maleta alta": "🧳 Tall suitcase",
      "🎸 Estuche instrumento": "🎸 Instrument case",
      "🏋️ Equipo deportivo": "🏋️ Sports equipment",
      "🧳 Maleta XXL": "🧳 XXL suitcase",
      "🏄 Tabla de surf": "🏄 Surfboard",
      "🚲 Bici plegable": "🚲 Folding bike",
      "🎿 Bolsa de ski": "🎿 Ski bag",
      "🏄 Tabla larga": "🏄 Long board",
      "🎻 Instrumento largo": "🎻 Long instrument",
      "🧳 Maleta extra alta": "🧳 Extra tall suitcase",
      //Time Selector View
      "¿Qué deseas hacer?": "What do you want to do?",
      "Selecciona una opción para continuar": "Select an option to continue",
      "ALQUILAR TAQUILLA": "RENT LOCKER",
      "Alquila una nueva taquilla por tiempo": "Rent a new locker by time",
      "ABRIR TAQUILLA ALQUILADA": "OPEN RENTED LOCKER",
      "Accede a tu taquilla con tus credenciales": "Access your locker with your credentials",
      "¿Cómo funciona?": "How does it work?",
      "Reserva tu taquilla": "Book your locker",
      "Elige tamaño y taquilla disponible.": "Choose a size and available locker.",
      "Selecciona el tiempo": "Select the time",
      "Elige la duración del alquiler.": "Choose the rental duration.",
      "Recibes tus credenciales": "Receive your credentials",
      "Te enviamos un email con tu código de acceso.": "We send you an email with your access code.",
      "Abre tu taquilla": "Open your locker",
      "Usa \"Abrir taquilla alquilada\" con tu teléfono y código.": "Use \"Open rented locker\" with your phone and code.",
      "Amplía el tiempo": "Extend the time",
      "Desde la pantalla de tu taquilla abierta puedes comprar más tiempo.": "From your open locker screen you can buy more time.",
      //Scan QR View
      "ESCANEA EL CÓDIGO QR": "SCAN THE QR CODE",
      "Para iniciar el proceso de reserva, escanea el código QR que encontrarás en la zona de taquillas con la cámara de tu teléfono.": "To start the booking process, scan the QR code you will find in the locker area with your phone camera.",
      //Rental Flow
      "Precio": "Price",
      "Sin precio": "No price",
      "Tipo de taquilla": "Locker type",
      "por": "for",
      "Datos": "Details",
      "Tiempo restante para completar la reserva": "Time remaining to complete the booking",
      "Tiempo agotado": "Time's up",
      "¿Salir de la reserva?": "Exit the booking?",
      "El tiempo para completar tu reserva ha expirado. La pre-reserva se liberará automáticamente.": "The time to complete your booking has expired. The pre-booking will be released automatically.",
      "Si sales ahora perderás la pre-reserva de taquillas. La selección se liberará automáticamente.": "If you leave now you will lose the locker pre-booking. The selection will be released automatically.",
      "Continuar reserva": "Continue booking",
      "Salir": "Leave",
      "Introduce tu nombre": "Enter your name",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "We're sorry, but we can no longer hold your locker. Please start the process again and complete the purchase within the stipulated time.",
      "¿Cancelar la compra?": "Cancel purchase?",
      "Continuar con el pago": "Continue with payment",
      "Tiempo para confirmar el pago": "Time to confirm payment",
      "Importe Original": "Original amount",
      "Total": "Total",
      "¿Necesitas cambiar algo?": "Need to change something?",
      "Cambiar datos": "Change details",
      "Cancelar": "Cancel",
      "El PIN se enviará al email el día de inicio de tu reserva": "The PIN will be sent to your email on the start date of your booking",
      "El PIN se ha enviado a tu email": "The PIN has been sent to your email",
      "AUTH": "AUTH",
      "FECHA": "DATE",
      "ACCESO A LOCAL": "VENUE ACCESS",
      "Código": "Code",
      "INSTRUCCIONES DE USO:": "INSTRUCTIONS FOR USE:"
    }
  },
  it: {
    translation: {
      //Generales
      "Confirmar": "Confermare",
      //Menu
      "Log in": "Accedi",
      "Exit": "Uscita",
      "TAQUILLA": "ARMADIETTO",
      "RESUMEN": "RIEPILOGO",
      "Mapa": "Mappa",
      //Step Bar
      "Zona": "Zona",
      "Taquilla": "Armadietto",
      "Pago": "Pagamento",
      "Email": "Email",
      //Home View
      "PARECE QUE ALGO HA FALLADO": "IT SEEMS SOMETHING HAS FAILED",
      "VUELVE A ESCANEAR EL QR": "SCAN THE QR AGAIN",
      //Zone Selector View
      "SELECCIONA LA ZONA DE TAQUILLAS": "SELEZIONA LA ZONA DEGLI ARMADIETTI",
      "BIENVENIDO A": "BENVENUTO A",
      "CONSULTA EL MAPA DEL PARQUE": "CONSULTA LA MAPPA DEL PARCO",
      "ZONA ": "ZONA ",
      //Locker Selector View
      "SELECCIONA EL TIPO DE TAQUILLA": "SELEZIONA IL TIPO DI ARMADIETTO",
      "PARQUE": "PARCO",
      "ZONA SELECCIONADA": "ZONA SELEZIONATA",
      "Taquilla": "Armadietto",
      "BÁSICA": "BASE",
      "BÁSICA CARGA": "BASE CON CARICATORE",
      "BÁSICA XL": "BASE XL",
      "BÁSICA CARGA XL": "BASE CON CARICATORE XL",
      "GRANDE": "GRANDE",
      "GRANDE CARGA": "GRANDE CON CARICATORE",
      "GRANDE XL": "GRANDE XL",
      "GRANDE CARGA XL": "GRANDE CON CARICATORE XL",
      "SKI": "SCI",
      "SKI CARGA": "SCI CON CARICATORE",
      "SKI XL": "SCI XL",
      "SKI CARGA XL": "SCI CON CARICATORE XL",
      "TAQUILLAS AGOTADAS": "ARMADIETTI ESAURITI",
      "Haz click aquí para volver a selección de zonas": "Clicca qui per tornare alla selezione della zona",
      //Accessibility View
      "¿NECESITAS UNA TAQUILLA ADAPTADA?": "HAI BISOGNO DI UN ARMADIETTO ADATTATO?",
      "Tienes la opción de seleccionar una taquilla de altura adaptada para tu confort.": "Hai la possibilità di selezionare un armadietto adattato in altezza per il tuo comfort.",
      "NO": "NO",
      "SI": "SÌ",
      //Payment View
      "CONFIRMA TU COMPRA": "CONFERMA IL TUO ACQUISTO",
      "Taquilla reservada durante": "Armadietto riservato per",
      "PARQUE": "PARCO",
      "ZONA": "ZONA",
      "ACCESIBLE": "ACCESSIBILE",
      "RESERVA": "PRENOTAZIONE",
      "TIPO DE TAQUILLA": "TIPO DI ARMADIETTO",
      "HASTA FINALIZAR EL DÍA": "FINO ALLA FINE DEL GIORNO",
      "IVA": "IVA",
      "IMPORTE BASE": "IMPORTO BASE",
      "IMPORTE IVA": "IMPORTO IVA",
      "TOTAL": "TOTALE",
      "Tiempo de reserva agotado": "Tempo di prenotazione scaduto",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo, otros usuarios deben poder acceder a ella. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "Ci dispiace, ma non possiamo riservare il tuo armadietto per più tempo, altri utenti devono potervi accedere. Inizia di nuovo il processo e completa l'acquisto entro il tempo stabilito.",
      "Volver al inicio": "Torna all'inizio",
      "¿Seguro que quieres salir?": "Sei sicuro di voler uscire?",
      "Si abandonas ahora, tu taquilla reservada quedará libre y otro usuario podrá alquilarla.": "Se esci ora, il tuo armadietto riservato verrà liberato e un altro utente potrà affittarlo.",
      "Continuar con el alquiler": "Continua con il noleggio",
      "Cancelar y salir": "Annulla ed esci",
      "¿Volver a editar tus datos?": "Modificare i tuoi dati?",
      "Tu taquilla permanecerá reservada mientras completas el formulario.": "Il tuo armadietto rimarrà riservato mentre completi il modulo.",
      "Quedarme aquí": "Rimani qui",
      "PAGAR": "PAGARE",
      "RESERVAR": "PRENOTARE",
      //Payment Error View
      "ERROR": "ERRORE",
      "No se ha podido realizar la compra. Vuelve a intentarlo más tarde.": "L'acquisto non ha potuto essere effettuato. Riprova più tardi.",
      "VOLVER": "TORNA A",
      "AL INICIO": "INIZIO",
      //Phone View
      "¡TU TAQUILLA HA SIDO RESERVADA!": "IL TUO ARMADIETTO È STATO PRENOTATO!",
      "FACILITANOS TUS DATOS DE RESPALDO": "FORNISCI I TUOI DATI DI BACKUP",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin de esta en caso de que lo pierdas. Al email te llegará la confirmación de tu reserva.": "Il tuo telefono sarà collegato all'armadietto prenotato per poter recuperare il suo PIN nel caso lo perdessi. Riceverai la conferma della tua prenotazione via email.",
      "TELÉFONO*": "NUMERO DI TELEFONO*",
      "EMAIL*": "EMAIL*",
      "Acepto ceder mi correo electrónico para recibir la confirmación de mi reserva.": "Accetto di fornire la mia email per ricevere la conferma della mia prenotazione.",
      "Acepto suscribirme al boletín informativo de VACWAY para recibir contenido y notificaciones comerciales.": "Accetto di iscrivermi alla newsletter di VACWAY per ricevere contenuti e notifiche commerciali.",
      "CONTINUAR": "CONTINUA",
      "*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.": "*I dati personali raccolti non saranno utilizzati in nessun caso per inviare comunicazioni commerciali di alcun tipo se il cliente non si iscrive alla newsletter.",
      //Ticket View
      "¡GRACIAS POR RESERVAR TU TAQUILLA!": "GRAZIE PER AVER PRENOTATO IL TUO ARMADIETTO!",
      "Sigue las instrucciones que encontrarás a continuación o en tu email.": "Segui le istruzioni che troverai di seguito o nella tua email.",
      "TICKET": "BIGLIETTO",
      "Nº TAQUILLA": "N° ARMADIETTO",
      "PIN": "PIN",
      "ZONA": "ZONA",
      "TIPO": "TIPO",
      "UBICACIÓN": "UBICAZIONE",
      "FACTURA": "FATTURA",
      "*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva.": "*Se desideri ottenere il PIN in formato fisico per portarlo durante il tuo soggiorno nel parco, contatta i responsabili dell'area degli armadietti e mostra loro l'email di prenotazione.",
      "Proceso completado, taquilla reservada.": "Processo completato, armadietto prenotato.",
      "Alquilar otra taquilla": "Noleggia un altro armadietto",
      "DESCARGAR TICKET": "SCARICA BIGLIETTO",
      "INSTRUCCIONES": "ISTRUZIONI",
      "PASO 1": "PASSO 1",
      "LOCALIZA TU TAQUILLA": "LOCALIZZA IL TUO ARMADIETTO",
      "PASO 2": "PASSO 2",
      "TOCA EL TECLADO": "TOCCA LA TASTIERA",
      "PASO 3": "PASSO 3",
      "INTRODUCE TU PIN": "INSERISCI IL TUO PIN",
      "PASO 4": "PASSO 4",
      "ABRE LAS VECES QUE QUIERAS": "APRI TANTE VOLTE QUANTE VUOI",
      "ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS": "APRI 1 VOLTA PER RIPORRE LE TUE COSE, UNA VOLTA CHIUSO NE HAI 1 IN PIÙ PER TIRARLE FUORI",
      //Ticket in Pdf (Ticket View)
      "Más información y garantía en www.vacway.com": "Ulteriori informazioni e garanzia su www.vacway.com",
      "Factura Simplificada": "Fattura Semplificata",
      "INFORMACIÓN DE TU LOCKER:": "INFORMAZIONI SUL TUO ARMADIETTO:",
      "Producto": "Prodotto",
      "UNIDADES": "Unità",
      "Fecha y Hora": "Data e Ora",
      "Reserva": "Rental",
      //LockerSelectorBaqueiraView
      "2 Equipos de esquí": "2 Set di sci",
      "3 Equipos de esquí": "3 Set di sci",
      "4 Equipos de esquí": "4 Set di sci",
      "Selecciona...": "Seleziona...",
      "Taquillas": "Armadi",
      "Atrás": "Indietro",
      "Continuar": "Avanti",
      "Fecha de Inicio": "Data di Inizio",
      "Fecha de Fin": "Data di Fine",
      "LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.": "CI DISPIACE, QUESTE DATE NON SONO DISPONIBILI. PROVA ALTRE DATE O UN ALTRO TIPO DI ARMADIO.",
      "ZONA": "ZONA",
      "TIPO": "TIPO",
      "CANTIDAD": "QUANTITÀ",
      "FECHAS": "DATE",
      "Selecciona el tipo de taquilla": "Seleziona il tipo di armadio",
      "Selecciona la cantidad": "Seleziona la quantità",
      "Selecciona las fechas": "Seleziona le date",
      "REVISA Y CONFIRMA": "VERIFICA E CONFERMA",
      "El día actual no está disponible para selección después de las 18:00 hora local.": "Il giorno corrente non è disponibile per la selezione dopo le 18:00 ora locale.",
      "El alquiler online está limitado a 14 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es": "L'affitto online è limitato a 14 giorni consecutivi, per prenotazioni a lungo termine contattare lo staff del Baqueira Store o richiederlo via email a skiservice@baqueira.es.",
      "Zona": "Zona",
      "Tipo": "Tipo",
      "Cantidad": "Quantità",
      "Fechas": "Date",
      "Importe": "Importo",
      "taquilla": "Armadietto",
      "taquillas": "Armadietti",
      "Inicio": "Inizio",
      "Fin": "Fine",
      "DD/MM/YYYY": "GG/MM/AAAA",
      "Descuento aplicado": "Sconto applicato: {{discount}}% (da {{days}} giorni)",
      "Lun": "Lun",
      "Mar": "Mar",
      "Mie": "Mer",
      "Jue": "Gio",
      "Vie": "Ven",
      "Sab": "Sab",
      "Dom": "Dom",
      //PhoneBaqueiraView
      "NOMBRE COMPLETO*": "NOME COMPLETO*",
      "Confirmo que he leído y acepto los términos y condiciones de uso del servicio.": "Confermo di aver letto e accettato i termini e le condizioni d'uso del servizio.",
      "Leer términos y condiciones.": "Leggi termini e condizioni.",
      //TicketBaqueiraView
      "Disponible en tu email que se enviará el día de inicio de tu reserva": "Disponibile nella tua email, che verrà inviata il giorno di inizio della tua prenotazione",
      "FECHA COMPRA": "DATA DI ACQUISTO",
      //PaymentBaqueiraView
      "Te hemos aplicado un descuento en el precio, solo vas a pagar 5 días de tu reserva!": "Ti abbiamo applicato uno sconto sul prezzo; pagherai solo 5 giorni della tua prenotazione!",
      "IMPORTE ORIGINAL": "IMPORTO ORIGINALE",
      "Lo sentimos, pero la venta no está disponible entre las 23:00h y la 01:00h, vuelva fuera de este horario.": "Ci dispiace, ma la vendita non è disponibile tra le 23:00 e l'01:00, torna fuori da questo orario.",
      "Fuera de horario": "Fuori orario",
      //PRERENTAL
      " por ": " ",
      "RESERVA DE TAQUILLAS": "PRENOTAZIONE ARMADIETTI",
      "Cantidad de taquillas": "Numero di armadietti",
      "Selecciona cuántas taquillas necesitas": "Seleziona quanti armadietti ti servono",
      "taquillas seleccionadas": "armadietti selezionati",
      "taquilla seleccionada": "armadietto selezionato",
      "RESERVA DE TAQUILLA": "PRENOTAZIONE ARMADIETTO",
      "Nombre Completo*": "Nome completo*",
      "Email*": "Email*",
      "Teléfono*": "Telefono*",
      "Confirmo que he leído y acepto los": "Confermo di aver letto e accetto i",
      "términos y condiciones": "termini e condizioni",
      "CONFIRMA TU COMPRA": "CONFERMA IL TUO ACQUISTO",
      "Tiempo para confirmar": "Tempo per confermare",
      "Revisa los datos de tu reserva": "Controlla i dati della tua prenotazione",
      "Zona:": "Zona:",
      "Inicio:": "Inizio:",
      "Nombre": "Nome",
      "Taquilla": "Armadietto",
      "Fin": "Fine",
      "Cantidad": "Quantità",
      "Hora Límite": "Orario limite",
      "Teléfono": "Telefono",
      "Confirma los importes": "Conferma gli importi",
      "Base": "Imponibile",
      "Pagar": "Paga",
      "IVA": "IVA",
      "Revisa los datos antes de confirmar el pago": "Controlla i tuoi dati prima di confermare il pagamento",
      "¿Necesitas hacer algún cambio?": "Hai bisogno di apportare modifiche?",
      "Editar mis datos": "Modifica i miei dati",
      "Cambiar taquilla": "Cambia armadietto",
      "Cancelar reserva": "Annulla prenotazione",
      "Resumen de reserva": "Riepilogo prenotazione",
      "Código de reserva": "Codice di prenotazione",
      "Información de taquilla": "Informazioni sull’armadietto",
      "Instrucciones": "Istruzioni",
      "DATOS DE RESPALDO": "DATI DI BACKUP",
      "Reservar": "Prenota ora",
      "Rellena los datos para ver disponibilidad": "Compila i dati per verificare la disponibilità",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin": "Il tuo telefono sarà collegato all’armadietto prenotato per poter recuperare il PIN",
      "Confirmar Email*": "Conferma Email*",
      "Repite tu email": "Ripeti la tua email",
      "Los emails no coinciden": "Le email non coincidono",
      "Tiempo para completar": "Tempo per completare",
      "Introduce tu email": "Inserisci la tua email",
      "Introduce tu teléfono": "Inserisci il tuo numero di telefono",
      "Documento de Identidad*": "Documento d’identità*",
      "DNI / NIE / Pasaporte": "Documento d’identità / Passaporto",
      //Locker Info Modal
      "Volver": "Indietro",
      "¿Qué cabe en esta taquilla?": "Cosa ci entra in questo armadietto?",
      "Ancho": "Larghezza",
      "Alto": "Altezza",
      "Fondo": "Profondità",
      "Ver información": "Visualizza informazioni",
      "Artículos compactos y anchos": "Articoli compatti e larghi",
      "Artículos pequeños": "Articoli piccoli",
      "Mochila urbana grande": "Zaino urbano grande",
      "Mochila urbana": "Zaino urbano",
      "Maleta de cabina y mochilas grandes": "Bagaglio a mano e zaini grandi",
      "Mochilas grandes y deporte": "Zaini grandi e sport",
      "Maleta mediana": "Valigia media",
      "Equipaje alto y estrecho": "Bagaglio alto e stretto",
      "Maleta grande de facturación": "Valigia grande da stiva",
      "Maleta alta y deporte": "Valigia alta e sport",
      "Equipaje extra grande": "Bagaglio extra grande",
      "Perfecta para cascos de bici o moto, bolsos de mano anchos y artículos personales voluminosos.": "Perfetta per caschi da bici o moto, borse a mano larghe e oggetti personali voluminosi.",
      "Ideal para cascos de bicicleta, bolsos pequeños y artículos personales de bolsillo.": "Ideale per caschi da bicicletta, borse piccole e oggetti personali tascabili.",
      "Cabe una mochila de ciudad amplia, bolsa de la compra o bolso de hombro de gran tamaño.": "Ci entra uno zaino urbano grande, una borsa della spesa o una borsa a tracolla di grandi dimensioni.",
      "Perfecta para mochila de portátil, bolsa de tela o chaqueta doblada.": "Perfetta per uno zaino per laptop, una borsa in tela o una giacca piegata.",
      "Admite mochilas de gran tamaño y maletas de cabina estándar (hasta 55 cm de alto, 40 cm de ancho).": "Accetta zaini di grandi dimensioni e bagagli a mano standard (fino a 55 cm di altezza, 40 cm di larghezza).",
      "Caben mochilas de trekking, bolsas de deporte y equipo de montaña.": "Ci entrano zaini da trekking, borse sportive e attrezzatura da montagna.",
      "Perfecta para maletas medianas de cabina y bolsas de deporte de gran tamaño.": "Perfetta per valigie medie da cabina e grandi borse sportive.",
      "Indicada para maletas delgadas en posición vertical o bolsas de esquí estrechas.": "Adatta per valigie sottili in posizione verticale o sacche da sci strette.",
      "Para maletas grandes de facturación y equipos deportivos voluminosos.": "Per grandi valigie da stiva e attrezzatura sportiva voluminosa.",
      "Para maletas altas y estrechas, bolsas de viaje largas o estuches de instrumentos.": "Per valigie alte e strette, borse da viaggio lunghe o custodie per strumenti.",
      "Nuestra taquilla más grande. Admite maletas enormes, tablas de surf, bolsas de ski o bicicletas plegadas.": "Il nostro armadietto più grande. Accetta valigie enormi, tavole da surf, sacche da sci o biciclette pieghevoli.",
      "Para equipos de gran formato: esquís, tablas largas, instrumentos o maletas extra altas.": "Per attrezzatura di grande formato: sci, tavole lunghe, strumenti o valigie extra alte.",
      "🪖 Casco bici / moto": "🪖 Casco bici/moto",
      "👜 Bolso de mano": "👜 Borsa a mano",
      "📦 Artículos pequeños": "📦 Articoli piccoli",
      "🪖 Casco bicicleta": "🪖 Casco bicicletta",
      "👜 Bolso pequeño": "👜 Borsa piccola",
      "🎒 Mochila mini": "🎒 Zaino mini",
      "🎒 Mochila urbana": "🎒 Zaino urbano",
      "🛍️ Bolsa de compras": "🛍️ Borsa della spesa",
      "👜 Bolso grande": "👜 Borsa grande",
      "🎒 Mochila portátil": "🎒 Zaino laptop",
      "🧥 Chaqueta": "🧥 Giacca",
      "🛍️ Bolsa de tela": "🛍️ Borsa in tela",
      "🧳 Maleta cabina": "🧳 Valigia cabina",
      "🎒 Mochila grande": "🎒 Zaino grande",
      "⛷️ Botas de esquí": "⛷️ Scarponi da sci",
      "🎒 Mochila trekking": "🎒 Zaino da trekking",
      "🏋️ Bolsa de deporte": "🏋️ Borsa sportiva",
      "🏕️ Equipo montaña": "🏕️ Attrezzatura da montagna",
      "🧳 Maleta mediana": "🧳 Valigia media",
      "🏋️ Bolsa deporte XL": "🏋️ Borsa sportiva XL",
      "🎿 Bolsa de esquí": "🎿 Sacca da sci",
      "🧳 Maleta delgada": "🧳 Valigia sottile",
      "🎿 Esquís": "🎿 Sci",
      "🏄 Tabla estrecha": "🏄 Tavola stretta",
      "🧳 Maleta grande": "🧳 Valigia grande",
      "🎿 Equipo esquí": "🎿 Attrezzatura sci",
      "🛹 Skateboard": "🛹 Skateboard",
      "🧳 Maleta alta": "🧳 Valigia alta",
      "🎸 Estuche instrumento": "🎸 Custodia strumento",
      "🏋️ Equipo deportivo": "🏋️ Attrezzatura sportiva",
      "🧳 Maleta XXL": "🧳 Valigia XXL",
      "🏄 Tabla de surf": "🏄 Tavola da surf",
      "🚲 Bici plegable": "🚲 Bici pieghevole",
      "🎿 Bolsa de ski": "🎿 Sacca da sci",
      "🏄 Tabla larga": "🏄 Tavola lunga",
      "🎻 Instrumento largo": "🎻 Strumento lungo",
      "🧳 Maleta extra alta": "🧳 Valigia extra alta",
      //Scan QR View
      "ESCANEA EL CÓDIGO QR": "SCANSIONA IL CODICE QR",
      "Para iniciar el proceso de reserva, escanea el código QR que encontrarás en la zona de taquillas con la cámara de tu teléfono.": "Per avviare il processo di prenotazione, scansiona il codice QR che troverai nella zona degli armadietti con la fotocamera del tuo telefono.",
      //Time Selector View
      "¿Qué deseas hacer?": "Cosa vuoi fare?",
      "Selecciona una opción para continuar": "Seleziona un'opzione per continuare",
      "ALQUILAR TAQUILLA": "NOLEGGIA ARMADIETTO",
      "Alquila una nueva taquilla por tiempo": "Noleggia un nuovo armadietto a tempo",
      "ABRIR TAQUILLA ALQUILADA": "APRI ARMADIETTO NOLEGGIATO",
      "Accede a tu taquilla con tus credenciales": "Accedi al tuo armadietto con le tue credenziali",
      "¿Cómo funciona?": "Come funziona?",
      "Reserva tu taquilla": "Prenota il tuo armadietto",
      "Elige tamaño y taquilla disponible.": "Scegli la dimensione e l'armadietto disponibile.",
      "Selecciona el tiempo": "Seleziona la durata",
      "Elige la duración del alquiler.": "Scegli la durata del noleggio.",
      "Recibes tus credenciales": "Ricevi le tue credenziali",
      "Te enviamos un email con tu código de acceso.": "Ti inviamo un'email con il tuo codice di accesso.",
      "Abre tu taquilla": "Apri il tuo armadietto",
      "Usa \"Abrir taquilla alquilada\" con tu teléfono y código.": "Usa \"Apri armadietto noleggiato\" con il tuo telefono e codice.",
      "Amplía el tiempo": "Estendi il tempo",
      "Desde la pantalla de tu taquilla abierta puedes comprar más tiempo.": "Dalla schermata del tuo armadietto aperto puoi acquistare più tempo.",
      //Rental Flow
      "Precio": "Prezzo",
      "Sin precio": "Nessun prezzo",
      "Tipo de taquilla": "Tipo di armadietto",
      "por": "per",
      "Datos": "Dati",
      "Tiempo restante para completar la reserva": "Tempo rimanente per completare la prenotazione",
      "Tiempo agotado": "Tempo scaduto",
      "¿Salir de la reserva?": "Uscire dalla prenotazione?",
      "El tiempo para completar tu reserva ha expirado. La pre-reserva se liberará automáticamente.": "Il tempo per completare la tua prenotazione è scaduto. La pre-prenotazione verrà rilasciata automaticamente.",
      "Si sales ahora perderás la pre-reserva de taquillas. La selección se liberará automáticamente.": "Se esci ora perderai la pre-prenotazione degli armadietti. La selezione verrà rilasciata automaticamente.",
      "Continuar reserva": "Continua prenotazione",
      "Salir": "Esci",
      "Introduce tu nombre": "Inserisci il tuo nome",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "Ci dispiace, ma non possiamo più mantenere la prenotazione del tuo armadietto. Ricomincia il processo e completa l'acquisto entro il tempo stabilito.",
      "¿Cancelar la compra?": "Annullare l'acquisto?",
      "Continuar con el pago": "Continua con il pagamento",
      "Tiempo para confirmar el pago": "Tempo per confermare il pagamento",
      "Importe Original": "Importo originale",
      "Total": "Totale",
      "¿Necesitas cambiar algo?": "Hai bisogno di cambiare qualcosa?",
      "Cambiar datos": "Cambia dati",
      "Cancelar": "Annulla",
      "El PIN se enviará al email el día de inicio de tu reserva": "Il PIN verrà inviato alla tua email il giorno di inizio della prenotazione",
      "El PIN se ha enviado a tu email": "Il PIN è stato inviato alla tua email",
      "AUTH": "AUTH",
      "FECHA": "DATA",
      "ACCESO A LOCAL": "ACCESSO AL LOCALE",
      "Código": "Codice",
      "INSTRUCCIONES DE USO:": "ISTRUZIONI PER L'USO:"
    }
  },
  fr: {
    translation: {
      //Generales
      "Confirmar": "Confirmer",
      //Menu
      "Log in": "Se connecter",
      "Exit": "Sortie",
      "TAQUILLA": "CASIER",
      "RESUMEN": "RÉSUMÉ",
      "Mapa": "Carte",
      //Step Bar
      "Zona": "Zone",
      "Taquilla": "Casier",
      "Pago": "Payer",
      "Email": "E-mail",
      //Home View
      "PARECE QUE ALGO HA FALLADO": "IT SEEMS SOMETHING HAS FAILED",
      "VUELVE A ESCANEAR EL QR": "SCAN THE QR AGAIN",
      //Zone Selector View
      "SELECCIONA LA ZONA DE TAQUILLAS": "SÉLECTIONNEZ LA ZONE DES CASIERS",
      "BIENVENIDO A": "BIENVENUE À",
      "CONSULTA EL MAPA DEL PARQUE": "CONSULTEZ LA CARTE DU PARC",
      "ZONA ": "ZONE ",
      //Locker Selector View
      "SELECCIONA EL TIPO DE TAQUILLA": "SÉLECTIONNEZ LE TYPE DE CASIER",
      "PARQUE": "PARC",
      "ZONA SELECCIONADA": "ZONE SÉLECTIONNÉE",
      "Taquilla": "Casier",
      "BÁSICA": "STANDARD",
      "BÁSICA CARGA": "STANDARD CHARGEUR",
      "BÁSICA XL": "STANDARD XL",
      "BÁSICA CARGA XL": "STANDARD CHARGEUR XL",
      "GRANDE": "GRAND",
      "GRANDE CARGA": "GRAND CHARGEUR",
      "GRANDE XL": "GRAND XL",
      "GRANDE CARGA XL": "GRAND CHARGEUR XL",
      "SKI": "SKI",
      "SKI CARGA": "SKI CHARGEUR",
      "SKI XL": "SKI XL",
      "SKI CARGA XL": "SKI CHARGEUR XL",
      "TAQUILLAS AGOTADAS": "CASIER ÉPUISÉ",
      "Haz click aquí para volver a selección de zonas": "Cliquez ici pour revenir à la sélection de la zone",
      //Accessibility View
      "¿NECESITAS UNA TAQUILLA ADAPTADA?": "AS-TU BESOIN D'UN CASIER ADAPTÉ ?",
      "Tienes la opción de seleccionar una taquilla de altura adaptada para tu confort.": "Vous avez la possibilité de sélectionner un casier adapté en hauteur pour votre confort.",
      "NO": "NON",
      "SI": "OUI",
      //Payment View
      "CONFIRMA TU COMPRA": "CONFIRMEZ VOTRE ACHAT",
      "Taquilla reservada durante": "Casier réservé pendant",
      "PARQUE": "PARC",
      "ZONA": "ZONE",
      "ACCESIBLE": "ACCESSIBLE",
      "RESERVA": "RÉSERVATION",
      "TIPO DE TAQUILLA": "TYPE DE CASIER",
      "HASTA FINALIZAR EL DÍA": "JUSQU'À LA FIN DE LA JOURNÉE",
      "IVA": "TVA",
      "IMPORTE BASE": "MONTANT DE BASE",
      "IMPORTE IVA": "MONTANT DE TVA",
      "TOTAL": "TOTAL",
      "Tiempo de reserva agotado": "Temps de réservation écoulé",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo, otros usuarios deben poder acceder a ella. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "Nous sommes désolés, mais nous ne pouvons pas réserver votre casier plus longtemps, d'autres utilisateurs doivent pouvoir y accéder. Revenez au début du processus et terminez l'achat dans le délai imparti.",
      "Volver al inicio": "Retour au début",
      "¿Seguro que quieres salir?": "Êtes-vous sûr de vouloir quitter?",
      "Si abandonas ahora, tu taquilla reservada quedará libre y otro usuario podrá alquilarla.": "Si vous partez maintenant, votre casier réservé sera libéré et un autre utilisateur pourra le louer.",
      "Continuar con el alquiler": "Continuer la location",
      "Cancelar y salir": "Annuler et quitter",
      "¿Volver a editar tus datos?": "Modifier vos coordonnées?",
      "Tu taquilla permanecerá reservada mientras completas el formulario.": "Votre casier restera réservé pendant que vous complétez le formulaire.",
      "Quedarme aquí": "Rester ici",
      "PAGAR": "PAYER",
      "RESERVAR": "RÉSERVER",
      //Payment Error View
      "ERROR": "ERREUR",
      "No se ha podido realizar la compra. Vuelve a intentarlo más tarde.": "L'achat n'a pas pu être effectué. Réessayez plus tard.",
      "VOLVER": "RETOUR",
      "AL INICIO": "AU DÉBUT",
      //Phone View
      "¡TU TAQUILLA HA SIDO RESERVADA!": "VOTRE CASIER A ÉTÉ RÉSERVÉ !",
      "FACILITANOS TUS DATOS DE RESPALDO": "FOURNISSEZ-NOUS VOS DONNÉES DE SAUVEGARDE",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin de esta en caso de que lo pierdas. Al email te llegará la confirmación de tu reserva.": "Votre téléphone sera lié au casier réservé pour pouvoir récupérer son code PIN en cas de perte. Vous recevrez la confirmation de votre réservation par e-mail.",
      "TELÉFONO*": "NUMÉRO DE TÉLÉPHONE*",
      "EMAIL*": "E-MAIL*",
      "Acepto ceder mi correo electrónico para recibir la confirmación de mi reserva.": "J'accepte de fournir mon e-mail pour recevoir la confirmation de ma réservation.",
      "Acepto suscribirme al boletín informativo de VACWAY para recibir contenido y notificaciones comerciales.": "J'accepte de m'abonner à la newsletter de VACWAY pour recevoir du contenu et des notifications commerciales.",
      "CONTINUAR": "CONTINUER",
      "*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.": "*Les données personnelles collectées ne seront en aucun cas utilisées pour offrir des communications commerciales d'aucune sorte si le client ne s'abonne pas à la newsletter.",
      //Ticket View
      "¡GRACIAS POR RESERVAR TU TAQUILLA!": "MERCI D'AVOIR RÉSERVÉ VOTRE CASIER !",
      "Sigue las instrucciones que encontrarás a continuación o en tu email.": "Suivez les instructions que vous trouverez ci-dessous ou dans votre e-mail.",
      "TICKET": "BILLET",
      "Nº TAQUILLA": "N° DE CASIER",
      "PIN": "PIN",
      "ZONA": "ZONE",
      "TIPO": "TYPE",
      "UBICACIÓN": "EMPLACEMENT",
      "FACTURA": "FACTURE",
      "*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva.": "*Si vous souhaitez obtenir le code PIN sous forme physique pour le porter pendant votre séjour dans le parc, contactez les responsables de la zone des casiers et montrez-leur votre e-mail de réservation.",
      "Proceso completado, taquilla reservada.": "Processus terminé, casier réservé.",
      "Alquilar otra taquilla": "Louer un autre casier",
      "DESCARGAR TICKET": "TÉLÉCHARGER LE BILLET",
      "INSTRUCCIONES": "INSTRUCTIONS",
      "PASO 1": "ÉTAPE 1",
      "LOCALIZA TU TAQUILLA": "LOCALISEZ VOTRE CASIER",
      "PASO 2": "ÉTAPE 2",
      "TOCA EL TECLADO": "TOUCHEZ LE CLAVIER",
      "PASO 3": "ÉTAPE 3",
      "INTRODUCE TU PIN": "SAISISSEZ VOTRE CODE PIN",
      "PASO 4": "ÉTAPE 4",
      "ABRE LAS VECES QUE QUIERAS": "OUVREZ AUTANT DE FOIS QUE VOUS VOULEZ",
      "ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS": "OUVREZ 1 FOIS POUR RANGER VOS AFFAIRES, UNE FOIS FERMÉ VOUS AVEZ 1 OUVERTURE SUPPLÉMENTAIRE POUR LES SORTIR",
      //Ticket in Pdf (Ticket View)
      "Más información y garantía en www.vacway.com": "Plus d'informations et garantie sur www.vacway.com",
      "Factura Simplificada": "Facture Simplifiée",
      "INFORMACIÓN DE TU LOCKER:": "INFORMATIONS SUR VOTRE CASIER :",
      "Producto": "Produit",
      "UNIDADES": "Unités",
      "Fecha y Hora": "Date et Heure",
      "Reserva": "Rental",
      //LockerSelectorBaqueiraView
      "2 Equipos de esquí": "2 Ensembles de skis",
      "3 Equipos de esquí": "3 Ensembles de skis",
      "4 Equipos de esquí": "4 Ensembles de skis",
      "Selecciona...": "Sélectionnez...",
      "Taquillas": "Casiers",
      "Atrás": "Retour",
      "Continuar": "Suivant",
      "Fecha de Inicio": "Date de Début",
      "Fecha de Fin": "Date de Fin",
      "LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.": "DÉSOLÉ, CES DATES NE SONT PAS DISPONIBLES. ESSAYEZ D'AUTRES DATES OU UN AUTRE TYPE DE CASIER.",
      "ZONA": "ZONE",
      "TIPO": "TYPE",
      "CANTIDAD": "QUANTITÉ",
      "FECHAS": "DATES",
      "Selecciona el tipo de taquilla": "Sélectionnez le type de casier",
      "Selecciona la cantidad": "Sélectionnez la quantité",
      "Selecciona las fechas": "Sélectionnez les dates",
      "REVISA Y CONFIRMA": "VÉRIFIEZ ET CONFIRMEZ",
      "El día actual no está disponible para selección después de las 18:00 hora local.": "Le jour actuel n'est pas disponible à la sélection après 18h00 heure locale.",
      "El alquiler online está limitado a 14 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es": "La location en ligne est limitée à 14 jours consécutifs, pour les réservations de longue durée, contactez le personnel du Baqueira Store ou faites-en la demande par e-mail à skiservice@baqueira.es.",
      "Zona": "Zone",
      "Tipo": "Type",
      "Cantidad": "Quantité",
      "Fechas": "Dates",
      "Importe": "Montant",
      "taquilla": "Casier",
      "taquillas": "Casiers",
      "Inicio": "Début",
      "Fin": "Fin",
      "DD/MM/YYYY": "JJ/MM/AAAA",
      "Descuento aplicado": "Remise appliquée : {{discount}}% (à partir de {{days}} jours)",
      "Lun": "Lun",
      "Mar": "Mar",
      "Mie": "Mer",
      "Jue": "Jeu",
      "Vie": "Ven",
      "Sab": "Sam",
      "Dom": "Dim",
      //PhoneBaqueiraView
      "NOMBRE COMPLETO*": "NOM COMPLET*",
      "Confirmo que he leído y acepto los términos y condiciones de uso del servicio.": "Je confirme avoir lu et accepté les termes et conditions d'utilisation du service.",
      "Leer términos y condiciones.": "Lire les termes et conditions.",
      //TicketBaqueiraView
      "Disponible en tu email que se enviará el día de inicio de tu reserva": "Disponible dans votre email, qui sera envoyé le jour du début de votre réservation",
      "FECHA COMPRA": "DATE D'ACHAT",
      //PaymentBaqueiraView
      "Te hemos aplicado un descuento en el precio, solo vas a pagar 5 días de tu reserva!": "Nous avons appliqué une réduction sur le prix; vous ne paierez que pour 5 jours de votre réservation!",
      "IMPORTE ORIGINAL": "MONTANT ORIGINAL",
      "Lo sentimos, pero la venta no está disponible entre las 23:00h y la 01:00h, vuelva fuera de este horario.": "Nous sommes désolés, mais les ventes ne sont pas disponibles entre 23h00 et 01h00, veuillez revenir en dehors de cet horaire.",
      "Fuera de horario": "Hors des heures d'ouverture",
      //PRERENTAL
      " por ": " ",
      "RESERVA DE TAQUILLAS": "RÉSERVATION DE CASIERS",
      "Cantidad de taquillas": "Nombre de casiers",
      "Selecciona cuántas taquillas necesitas": "Sélectionnez le nombre de casiers dont vous avez besoin",
      "taquillas seleccionadas": "casiers sélectionnés",
      "taquilla seleccionada": "casier sélectionné",
      "RESERVA DE TAQUILLA": "RÉSERVATION DE CASIER",
      "Nombre Completo*": "Nom complet*",
      "Email*": "E-mail*",
      "Teléfono*": "Téléphone*",
      "Confirmo que he leído y acepto los": "Je confirme avoir lu et accepté les",
      "términos y condiciones": "termes et conditions",
      "CONFIRMA TU COMPRA": "CONFIRMEZ VOTRE ACHAT",
      "Tiempo para confirmar": "Temps pour confirmer",
      "Revisa los datos de tu reserva": "Vérifiez les détails de votre réservation",
      "Zona:": "Zone :",
      "Inicio:": "Début :",
      "Nombre": "Nom",
      "Taquilla": "Casier",
      "Fin": "Fin",
      "Cantidad": "Quantité",
      "Hora Límite": "Heure limite",
      "Teléfono": "Téléphone",
      "Confirma los importes": "Confirmez les montants",
      "Base": "Sous-total",
      "Pagar": "Payer",
      "IVA": "TVA",
      "Revisa los datos antes de confirmar el pago": "Vérifiez vos informations avant de confirmer le paiement",
      "¿Necesitas hacer algún cambio?": "Vous avez besoin d'apporter des modifications?",
      "Editar mis datos": "Modifier mes coordonnées",
      "Cambiar taquilla": "Changer de casier",
      "Cancelar reserva": "Annuler la réservation",
      "Resumen de reserva": "Récapitulatif de la réservation",
      "Código de reserva": "Code de réservation",
      "Información de taquilla": "Informations sur le casier",
      "Instrucciones": "Instructions",
      "DATOS DE RESPALDO": "DONNÉES DE SAUVEGARDE",
      "Reservar": "Réserver maintenant",
      "Rellena los datos para ver disponibilidad": "Remplissez les informations pour vérifier la disponibilité",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin": "Votre téléphone sera lié au casier réservé afin de pouvoir récupérer le code PIN",
      "Confirmar Email*": "Confirmer l'e-mail*",
      "Repite tu email": "Répétez votre e-mail",
      "Los emails no coinciden": "Les e-mails ne correspondent pas",
      "Tiempo para completar": "Temps pour compléter",
      "Introduce tu email": "Entrez votre e-mail",
      "Introduce tu teléfono": "Entrez votre numéro de téléphone",
      "Documento de Identidad*": "Document d'identité*",
      "DNI / NIE / Pasaporte": "Pièce d'identité / Passeport",
      //Locker Info Modal
      "Volver": "Retour",
      "¿Qué cabe en esta taquilla?": "Qu'est-ce qui rentre dans ce casier?",
      "Ancho": "Largeur",
      "Alto": "Hauteur",
      "Fondo": "Profondeur",
      "Ver información": "Voir les informations",
      "Artículos compactos y anchos": "Articles compacts et larges",
      "Artículos pequeños": "Petits articles",
      "Mochila urbana grande": "Grand sac à dos urbain",
      "Mochila urbana": "Sac à dos urbain",
      "Maleta de cabina y mochilas grandes": "Bagage cabine et grands sacs à dos",
      "Mochilas grandes y deporte": "Grands sacs à dos et sport",
      "Maleta mediana": "Valise moyenne",
      "Equipaje alto y estrecho": "Bagages hauts et étroits",
      "Maleta grande de facturación": "Grande valise enregistrée",
      "Maleta alta y deporte": "Valise haute et sport",
      "Equipaje extra grande": "Bagages extra larges",
      "Perfecta para cascos de bici o moto, bolsos de mano anchos y artículos personales voluminosos.": "Parfait pour les casques de vélo ou moto, les sacs à main larges et les articles personnels encombrants.",
      "Ideal para cascos de bicicleta, bolsos pequeños y artículos personales de bolsillo.": "Idéal pour les casques de vélo, les petits sacs et les articles personnels de poche.",
      "Cabe una mochila de ciudad amplia, bolsa de la compra o bolso de hombro de gran tamaño.": "Contient un grand sac à dos de ville, un sac de courses ou un grand sac à bandoulière.",
      "Perfecta para mochila de portátil, bolsa de tela o chaqueta doblada.": "Parfait pour un sac à dos ordinateur, un tote bag ou une veste pliée.",
      "Admite mochilas de gran tamaño y maletas de cabina estándar (hasta 55 cm de alto, 40 cm de ancho).": "Accepte les grands sacs à dos et les bagages cabine standard (jusqu'à 55 cm de hauteur, 40 cm de largeur).",
      "Caben mochilas de trekking, bolsas de deporte y equipo de montaña.": "Contient des sacs à dos de randonnée, des sacs de sport et du matériel de montagne.",
      "Perfecta para maletas medianas de cabina y bolsas de deporte de gran tamaño.": "Parfait pour les valises moyennes de cabine et les grands sacs de sport.",
      "Indicada para maletas delgadas en posición vertical o bolsas de esquí estrechas.": "Convient aux valises fines debout ou aux sacs de ski étroits.",
      "Para maletas grandes de facturación y equipos deportivos voluminosos.": "Pour les grandes valises enregistrées et les équipements sportifs encombrants.",
      "Para maletas altas y estrechas, bolsas de viaje largas o estuches de instrumentos.": "Pour les valises hautes et étroites, les grands sacs de voyage ou les étuis à instruments.",
      "Nuestra taquilla más grande. Admite maletas enormes, tablas de surf, bolsas de ski o bicicletas plegadas.": "Notre plus grand casier. Accepte les énormes valises, les planches de surf, les sacs de ski ou les vélos pliants.",
      "Para equipos de gran formato: esquís, tablas largas, instrumentos o maletas extra altas.": "Pour les équipements grand format : skis, longues planches, instruments ou valises extra-hautes.",
      "🪖 Casco bici / moto": "🪖 Casque vélo/moto",
      "👜 Bolso de mano": "👜 Sac à main",
      "📦 Artículos pequeños": "📦 Petits articles",
      "🪖 Casco bicicleta": "🪖 Casque vélo",
      "👜 Bolso pequeño": "👜 Petit sac",
      "🎒 Mochila mini": "🎒 Mini sac à dos",
      "🎒 Mochila urbana": "🎒 Sac à dos urbain",
      "🛍️ Bolsa de compras": "🛍️ Sac de courses",
      "👜 Bolso grande": "👜 Grand sac",
      "🎒 Mochila portátil": "🎒 Sac à dos ordinateur",
      "🧥 Chaqueta": "🧥 Veste",
      "🛍️ Bolsa de tela": "🛍️ Tote bag",
      "🧳 Maleta cabina": "🧳 Valise cabine",
      "🎒 Mochila grande": "🎒 Grand sac à dos",
      "⛷️ Botas de esquí": "⛷️ Chaussures de ski",
      "🎒 Mochila trekking": "🎒 Sac à dos randonnée",
      "🏋️ Bolsa de deporte": "🏋️ Sac de sport",
      "🏕️ Equipo montaña": "🏕️ Équipement montagne",
      "🧳 Maleta mediana": "🧳 Valise moyenne",
      "🏋️ Bolsa deporte XL": "🏋️ Sac de sport XL",
      "🎿 Bolsa de esquí": "🎿 Sac de ski",
      "🧳 Maleta delgada": "🧳 Valise fine",
      "🎿 Esquís": "🎿 Skis",
      "🏄 Tabla estrecha": "🏄 Planche étroite",
      "🧳 Maleta grande": "🧳 Grande valise",
      "🎿 Equipo esquí": "🎿 Équipement ski",
      "🛹 Skateboard": "🛹 Skateboard",
      "🧳 Maleta alta": "🧳 Valise haute",
      "🎸 Estuche instrumento": "🎸 Étui à instrument",
      "🏋️ Equipo deportivo": "🏋️ Équipement sportif",
      "🧳 Maleta XXL": "🧳 Valise XXL",
      "🏄 Tabla de surf": "🏄 Planche de surf",
      "🚲 Bici plegable": "🚲 Vélo pliant",
      "🎿 Bolsa de ski": "🎿 Sac de ski",
      "🏄 Tabla larga": "🏄 Longboard",
      "🎻 Instrumento largo": "🎻 Instrument long",
      "🧳 Maleta extra alta": "🧳 Valise extra haute",
      //Time Selector View
      "¿Qué deseas hacer?": "Que souhaitez-vous faire?",
      "Selecciona una opción para continuar": "Sélectionnez une option pour continuer",
      "ALQUILAR TAQUILLA": "LOUER UN CASIER",
      "Alquila una nueva taquilla por tiempo": "Louez un nouveau casier à la durée",
      "ABRIR TAQUILLA ALQUILADA": "OUVRIR LE CASIER LOUÉ",
      "Accede a tu taquilla con tus credenciales": "Accédez à votre casier avec vos identifiants",
      "¿Cómo funciona?": "Comment ça marche?",
      "Reserva tu taquilla": "Réservez votre casier",
      "Elige tamaño y taquilla disponible.": "Choisissez la taille et le casier disponible.",
      "Selecciona el tiempo": "Sélectionnez la durée",
      "Elige la duración del alquiler.": "Choisissez la durée de location.",
      "Recibes tus credenciales": "Recevez vos identifiants",
      "Te enviamos un email con tu código de acceso.": "Nous vous envoyons un e-mail avec votre code d'accès.",
      "Abre tu taquilla": "Ouvrez votre casier",
      "Usa \"Abrir taquilla alquilada\" con tu teléfono y código.": "Utilisez \"Ouvrir le casier loué\" avec votre téléphone et code.",
      "Amplía el tiempo": "Prolongez le temps",
      "Desde la pantalla de tu taquilla abierta puedes comprar más tiempo.": "Depuis l'écran de votre casier ouvert, vous pouvez acheter plus de temps.",
      //Scan QR View
      "ESCANEA EL CÓDIGO QR": "SCANNEZ LE CODE QR",
      "Para iniciar el proceso de reserva, escanea el código QR que encontrarás en la zona de taquillas con la cámara de tu teléfono.": "Pour démarrer le processus de réservation, scannez le code QR que vous trouverez dans la zone des casiers avec l'appareil photo de votre téléphone.",
      //Rental Flow
      "Precio": "Prix",
      "Sin precio": "Sans prix",
      "Tipo de taquilla": "Type de casier",
      "por": "pour",
      "Datos": "Coordonnées",
      "Tiempo restante para completar la reserva": "Temps restant pour compléter la réservation",
      "Tiempo agotado": "Temps écoulé",
      "¿Salir de la reserva?": "Quitter la réservation ?",
      "El tiempo para completar tu reserva ha expirado. La pre-reserva se liberará automáticamente.": "Le temps pour compléter votre réservation a expiré. La pré-réservation sera libérée automatiquement.",
      "Si sales ahora perderás la pre-reserva de taquillas. La selección se liberará automáticamente.": "Si vous quittez maintenant, vous perdrez la pré-réservation des casiers. La sélection sera libérée automatiquement.",
      "Continuar reserva": "Continuer la réservation",
      "Salir": "Quitter",
      "Introduce tu nombre": "Entrez votre nom",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "Nous sommes désolés, mais nous ne pouvons plus réserver votre casier. Veuillez redémarrer le processus et finaliser l'achat dans le délai imparti.",
      "¿Cancelar la compra?": "Annuler l'achat ?",
      "Continuar con el pago": "Continuer avec le paiement",
      "Tiempo para confirmar el pago": "Temps pour confirmer le paiement",
      "Importe Original": "Montant original",
      "Total": "Total",
      "¿Necesitas cambiar algo?": "Besoin de changer quelque chose ?",
      "Cambiar datos": "Modifier les données",
      "Cancelar": "Annuler",
      "El PIN se enviará al email el día de inicio de tu reserva": "Le code PIN sera envoyé à votre e-mail le jour du début de votre réservation",
      "El PIN se ha enviado a tu email": "Le code PIN a été envoyé à votre e-mail",
      "AUTH": "AUTH",
      "FECHA": "DATE",
      "ACCESO A LOCAL": "ACCÈS AU LOCAL",
      "Código": "Code",
      "INSTRUCCIONES DE USO:": "INSTRUCTIONS D'UTILISATION :"
    }
  },
  pt: {
    translation: {
      //Generales
      "Confirmar": "Confirmar",
      //Menu
      "Log in": "Entrar",
      "Exit": "Sair",
      "TAQUILLA": "ARMÁRIO",
      "RESUMEN": "RESUMO",
      "Mapa": "Mapa",
      //Step Bar
      "Zona": "Zona",
      "Taquilla": "Armário",
      "Pago": "Pagamento",
      "Email": "E-mail",
      //Home View
      "PARECE QUE ALGO HA FALLADO": "IT SEEMS SOMETHING HAS FAILED",
      "VUELVE A ESCANEAR EL QR": "SCAN THE QR AGAIN",
      //Zone Selector View
      "SELECCIONA LA ZONA DE TAQUILLAS": "SELECIONE A ZONA DOS ARMÁRIOS",
      "BIENVENIDO A": "BEM-VINDO AO",
      "CONSULTA EL MAPA DEL PARQUE": "CONSULTE O MAPA DO PARQUE",
      "ZONA ": "ZONA ",
      //Locker Selector View
      "SELECCIONA EL TIPO DE TAQUILLA": "SELECIONE O TIPO DE ARMÁRIO",
      "PARQUE": "PARQUE",
      "ZONA SELECCIONADA": "ZONA SELECIONADA",
      "Taquilla": "Armário",
      "BÁSICA": "BÁSICA",
      "BÁSICA CARGA": "BÁSICA COM CARREGADOR",
      "BÁSICA XL": "BÁSICA XL",
      "BÁSICA CARGA XL": "BÁSICA COM CARREGADOR XL",
      "GRANDE": "GRANDE",
      "GRANDE CARGA": "GRANDE COM CARREGADOR",
      "GRANDE XL": "GRANDE XL",
      "GRANDE CARGA XL": "GRANDE COM CARREGADOR XL",
      "SKI": "ESQUI",
      "SKI CARGA": "ESQUI COM CARREGADOR",
      "SKI XL": "ESQUI XL",
      "SKI CARGA XL": "ESQUI COM CARREGADOR XL",
      "TAQUILLAS AGOTADAS": "ARMÁRIOS ESGOTADOS",
      "Haz click aquí para volver a selección de zonas": "Clique aqui para voltar à seleção de zona",
      //Accessibility View
      "¿NECESITAS UNA TAQUILLA ADAPTADA?": "PRECISA DE UM ARMÁRIO ADAPTADO?",
      "Tienes la opción de seleccionar una taquilla de altura adaptada para tu confort.": "Você tem a opção de selecionar um armário adaptado em altura para o seu conforto.",
      "NO": "NÃO",
      "SI": "SIM",
      //Payment View
      "CONFIRMA TU COMPRA": "CONFIRME A SUA COMPRA",
      "Taquilla reservada durante": "Armário reservado durante",
      "PARQUE": "PARQUE",
      "ZONA": "ZONA",
      "ACCESIBLE": "ACESSÍVEL",
      "RESERVA": "RESERVA",
      "TIPO DE TAQUILLA": "TIPO DE ARMÁRIO",
      "HASTA FINALIZAR EL DÍA": "ATÉ O FINAL DO DIA",
      "IVA": "IVA",
      "IMPORTE BASE": "VALOR BASE",
      "IMPORTE IVA": "VALOR DO IVA",
      "TOTAL": "TOTAL",
      "Tiempo de reserva agotado": "Tempo de reserva esgotado",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo, otros usuarios deben poder acceder a ella. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "Lamentamos, mas não podemos reservar seu armário por mais tempo; outros usuários devem ter acesso a ele. Inicie o processo novamente e conclua a compra dentro do tempo estipulado.",
      "Volver al inicio": "Voltar ao início",
      "¿Seguro que quieres salir?": "Tem certeza que quer sair?",
      "Si abandonas ahora, tu taquilla reservada quedará libre y otro usuario podrá alquilarla.": "Se sair agora, o seu armário reservado ficará livre e outro utilizador poderá alugá-lo.",
      "Continuar con el alquiler": "Continuar com o aluguer",
      "Cancelar y salir": "Cancelar e sair",
      "¿Volver a editar tus datos?": "Editar os seus dados?",
      "Tu taquilla permanecerá reservada mientras completas el formulario.": "O seu armário permanecerá reservado enquanto preenche o formulário.",
      "Quedarme aquí": "Ficar aqui",
      "PAGAR": "PAGAR",
      "RESERVAR": "RESERVAR",
      //Payment Error View
      "ERROR": "ERRO",
      "No se ha podido realizar la compra. Vuelve a intentarlo más tarde.": "Não foi possível efetuar a compra. Tente novamente mais tarde.",
      "VOLVER": "VOLTAR",
      "AL INICIO": "INÍCIO",
      //Phone View
      "¡TU TAQUILLA HA SIDO RESERVADA!": "SEU ARMÁRIO FOI RESERVADO!",
      "FACILITANOS TUS DATOS DE RESPALDO": "FORNEÇA SEUS DADOS DE BACKUP",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin de esta en caso de que lo pierdas. Al email te llegará la confirmación de tu reserva.": "Seu telefone será vinculado ao armário reservado para poder recuperar seu PIN caso você o perca. A confirmação da sua reserva será enviada por e-mail.",
      "TELÉFONO*": "NÚMERO DE TELEFONE*",
      "EMAIL*": "E-MAIL*",
      "Acepto ceder mi correo electrónico para recibir la confirmación de mi reserva.": "Aceito fornecer meu e-mail para receber a confirmação da minha reserva.",
      "Acepto suscribirme al boletín informativo de VACWAY para recibir contenido y notificaciones comerciales.": "Aceito assinar a newsletter da VACWAY para receber conteúdo e notificações comerciais.",
      "CONTINUAR": "CONTINUAR",
      "*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.": "*Os dados pessoais coletados não serão usados, em nenhum caso, para oferecer comunicações comerciais de nenhum tipo, caso o cliente não assine a newsletter.",
      //Ticket View
      "¡GRACIAS POR RESERVAR TU TAQUILLA!": "OBRIGADO POR RESERVAR SEU ARMÁRIO!",
      "Sigue las instrucciones que encontrarás a continuación o en tu email.": "Siga as instruções que você encontrará abaixo ou no seu e-mail.",
      "TICKET": "BILHETE",
      "Nº TAQUILLA": "Nº DE ARMÁRIO",
      "PIN": "PIN",
      "ZONA": "ZONA",
      "TIPO": "TIPO",
      "UBICACIÓN": "LOCALIZAÇÃO",
      "FACTURA": "FATURA",
      "*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva.": "*Se você deseja obter o PIN em formato físico para levar durante sua estadia no parque, entre em contato com os responsáveis da área de armários e mostre-lhes seu e-mail de reserva.",
      "Proceso completado, taquilla reservada.": "Processo concluído, armário reservado.",
      "Alquilar otra taquilla": "Alugar outro armário",
      "DESCARGAR TICKET": "BAIXAR BILHETE",
      "INSTRUCCIONES": "INSTRUÇÕES",
      "PASO 1": "PASSO 1",
      "LOCALIZA TU TAQUILLA": "LOCALIZE SEU ARMÁRIO",
      "PASO 2": "PASSO 2",
      "TOCA EL TECLADO": "TOQUE NO TECLADO",
      "PASO 3": "PASSO 3",
      "INTRODUCE TU PIN": "INSIRA SEU PIN",
      "PASO 4": "PASSO 4",
      "ABRE LAS VECES QUE QUIERAS": "ABRA QUANTAS VEZES QUISER",
      "ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS": "ABRA 1 VEZ PARA GUARDAR SUAS COISAS, UMA VEZ FECHADO, VOCÊ TEM MAIS 1 ABERTURA PARA TIRÁ-LAS",
      //Ticket in Pdf (Ticket View)
      "Más información y garantía en www.vacway.com": "Mais informações e garantia em www.vacway.com",
      "Factura Simplificada": "Fatura Simplificada",
      "INFORMACIÓN DE TU LOCKER:": "INFORMAÇÕES DO SEU ARMÁRIO:",
      "Producto": "Produto",
      "UNIDADES": "Unidades",
      "Fecha y Hora": "Data e Hora",
      "Reserva": "Rental",
      //LockerSelectorBaqueiraView
      "2 Equipos de esquí": "2 Conjuntos de esquis",
      "3 Equipos de esquí": "3 Conjuntos de esquis",
      "4 Equipos de esquí": "4 Conjuntos de esquis",
      "Selecciona...": "Selecione...",
      "Taquillas": "Armários",
      "Atrás": "Voltar",
      "Continuar": "Avançar",
      "Fecha de Inicio": "Data de Início",
      "Fecha de Fin": "Data de Fim",
      "LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.": "DESCULPE, ESTAS DATAS NÃO ESTÃO DISPONÍVEIS. TENTE OUTRAS DATAS OU OUTRO TIPO DE ARMÁRIO.",
      "ZONA": "ZONA",
      "TIPO": "TIPO",
      "CANTIDAD": "QUANTIDADE",
      "FECHAS": "DATAS",
      "Selecciona el tipo de taquilla": "Selecione o tipo de armário",
      "Selecciona la cantidad": "Selecione a quantidade",
      "Selecciona las fechas": "Selecione as datas",
      "REVISA Y CONFIRMA": "VERIFIQUE E CONFIRME",
      "El día actual no está disponible para selección después de las 18:00 hora local.": "O dia atual não está disponível para seleção após as 18h00, hora local.",
      "El alquiler online está limitado a 14 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es": "O aluguel online está limitado a 14 dias consecutivos. Para reservas de longa duração, entre em contato com a equipe da Baqueira Store ou solicite via e-mail para skiservice@baqueira.es.",
      "Zona": "Zona",
      "Tipo": "Tipo",
      "Cantidad": "Quantidade",
      "Fechas": "Datas",
      "Importe": "Valor",
      "taquilla": "Armário",
      "taquillas": "Armários",
      "Inicio": "Início",
      "Fin": "Fim",
      "DD/MM/YYYY": "DD/MM/AAAA",
      "Descuento aplicado": "Desconto aplicado: {{discount}}% (a partir de {{days}} dias)",
      "Lun": "Seg",
      "Mar": "Ter",
      "Mie": "Qua",
      "Jue": "Qui",
      "Vie": "Sex",
      "Sab": "Sáb",
      "Dom": "Dom",
      //PhoneBaqueiraView
      "NOMBRE COMPLETO*": "NOME COMPLETO*",
      "Confirmo que he leído y acepto los términos y condiciones de uso del servicio.": "Confirmo que li e aceito os termos e condições de uso do serviço.",
      "Leer términos y condiciones.": "Ler termos e condições.",
      //TicketBaqueiraView
      "Disponible en tu email que se enviará el día de inicio de tu reserva": "Disponível no seu email, que será enviado no dia de início da sua reserva",
      "FECHA COMPRA": "DATA DE COMPRA",
      //PaymentBaqueiraView
      "Te hemos aplicado un descuento en el precio, solo vas a pagar 5 días de tu reserva!": "Aplicamos um desconto no preço; você pagará apenas 5 dias da sua reserva!",
      "IMPORTE ORIGINAL": "VALOR ORIGINAL",
      "Lo sentimos, pero la venta no está disponible entre las 23:00h y la 01:00h, vuelva fuera de este horario.": "Lamentamos, mas as vendas não estão disponíveis entre as 23:00 e a 01:00, por favor volte fora deste horário.",
      "Fuera de horario": "Fora de horário",
      //PRERRENTAL
      " por ": " ",
      "RESERVA DE TAQUILLAS": "RESERVA DE ARMÁRIOS",
      "Cantidad de taquillas": "Número de armários",
      "Selecciona cuántas taquillas necesitas": "Selecione quantos armários você precisa",
      "taquillas seleccionadas": "armários selecionados",
      "taquilla seleccionada": "armário selecionado",
      "RESERVA DE TAQUILLA": "RESERVA DE ARMÁRIO",
      "Nombre Completo*": "Nome completo*",
      "Email*": "E-mail*",
      "Teléfono*": "Telefone*",
      "Confirmo que he leído y acepto los": "Confirmo que li e aceito os",
      "términos y condiciones": "termos e condições",
      "CONFIRMA TU COMPRA": "CONFIRME SUA COMPRA",
      "Tiempo para confirmar": "Tempo para confirmar",
      "Revisa los datos de tu reserva": "Verifique os dados da sua reserva",
      "Zona:": "Zona:",
      "Inicio:": "Início:",
      "Nombre": "Nome",
      "Taquilla": "Armário",
      "Fin": "Fim",
      "Cantidad": "Quantidade",
      "Hora Límite": "Hora limite",
      "Teléfono": "Telefone",
      "Confirma los importes": "Confirme os valores",
      "Base": "Subtotal",
      "Pagar": "Pagar",
      "IVA": "IVA",
      "Revisa los datos antes de confirmar el pago": "Revise os seus dados antes de confirmar o pagamento",
      "¿Necesitas hacer algún cambio?": "Precisa fazer alguma alteração?",
      "Editar mis datos": "Editar os meus dados",
      "Cambiar taquilla": "Mudar de armário",
      "Cancelar reserva": "Cancelar reserva",
      "Resumen de reserva": "Resumo da reserva",
      "Código de reserva": "Código da reserva",
      "Información de taquilla": "Informações do armário",
      "Instrucciones": "Instruções",
      "DATOS DE RESPALDO": "DADOS DE BACKUP",
      "Reservar": "Reservar agora",
      "Rellena los datos para ver disponibilidad": "Preencha os dados para verificar a disponibilidade",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin": "Seu telefone será vinculado ao armário reservado para que você possa recuperar o PIN",
      "Confirmar Email*": "Confirmar E-mail*",
      "Repite tu email": "Repita seu e-mail",
      "Los emails no coinciden": "Os e-mails não coincidem",
      "Tiempo para completar": "Tempo para completar",
      "Introduce tu email": "Insira seu e-mail",
      "Introduce tu teléfono": "Insira seu número de telefone",
      "Documento de Identidad*": "Documento de identidade*",
      "DNI / NIE / Pasaporte": "Documento de identidade / Passaporte",
      //Locker Info Modal
      "Volver": "Voltar",
      "¿Qué cabe en esta taquilla?": "O que cabe neste armário?",
      "Ancho": "Largura",
      "Alto": "Altura",
      "Fondo": "Profundidade",
      "Ver información": "Ver informações",
      "Artículos compactos y anchos": "Artigos compactos e largos",
      "Artículos pequeños": "Artigos pequenos",
      "Mochila urbana grande": "Mochila urbana grande",
      "Mochila urbana": "Mochila urbana",
      "Maleta de cabina y mochilas grandes": "Bagagem de cabine e mochilas grandes",
      "Mochilas grandes y deporte": "Mochilas grandes e desporto",
      "Maleta mediana": "Mala média",
      "Equipaje alto y estrecho": "Bagagem alta e estreita",
      "Maleta grande de facturación": "Mala grande de despacho",
      "Maleta alta y deporte": "Mala alta e desporto",
      "Equipaje extra grande": "Bagagem extra grande",
      "Perfecta para cascos de bici o moto, bolsos de mano anchos y artículos personales voluminosos.": "Perfeita para capacetes de bicicleta ou moto, bolsas de mão largas e artigos pessoais volumosos.",
      "Ideal para cascos de bicicleta, bolsos pequeños y artículos personales de bolsillo.": "Ideal para capacetes de bicicleta, bolsas pequenas e artigos pessoais de bolso.",
      "Cabe una mochila de ciudad amplia, bolsa de la compra o bolso de hombro de gran tamaño.": "Cabe uma mochila de cidade ampla, saco de compras ou bolsa de ombro de grande tamanho.",
      "Perfecta para mochila de portátil, bolsa de tela o chaqueta doblada.": "Perfeita para mochila de laptop, saco de tecido ou casaco dobrado.",
      "Admite mochilas de gran tamaño y maletas de cabina estándar (hasta 55 cm de alto, 40 cm de ancho).": "Admite mochilas de grande tamanho e malas de cabine padrão (até 55 cm de altura, 40 cm de largura).",
      "Caben mochilas de trekking, bolsas de deporte y equipo de montaña.": "Cabem mochilas de trekking, bolsas de desporto e equipamento de montanha.",
      "Perfecta para maletas medianas de cabina y bolsas de deporte de gran tamaño.": "Perfeita para malas médias de cabine e bolsas de desporto de grande tamanho.",
      "Indicada para maletas delgadas en posición vertical o bolsas de esquí estrechas.": "Indicada para malas finas em posição vertical ou sacos de esqui estreitos.",
      "Para maletas grandes de facturación y equipos deportivos voluminosos.": "Para malas grandes de despacho e equipamentos desportivos volumosos.",
      "Para maletas altas y estrechas, bolsas de viaje largas o estuches de instrumentos.": "Para malas altas e estreitas, bolsas de viagem compridas ou estojos de instrumentos.",
      "Nuestra taquilla más grande. Admite maletas enormes, tablas de surf, bolsas de ski o bicicletas plegadas.": "O nosso maior armário. Admite malas enormes, pranchas de surf, sacos de ski ou bicicletas dobradas.",
      "Para equipos de gran formato: esquís, tablas largas, instrumentos o maletas extra altas.": "Para equipamentos de grande formato: esquis, pranchas compridas, instrumentos ou malas extra altas.",
      "🪖 Casco bici / moto": "🪖 Capacete bici/moto",
      "👜 Bolso de mano": "👜 Bolsa de mão",
      "📦 Artículos pequeños": "📦 Artigos pequenos",
      "🪖 Casco bicicleta": "🪖 Capacete bicicleta",
      "👜 Bolso pequeño": "👜 Bolsa pequena",
      "🎒 Mochila mini": "🎒 Mochila mini",
      "🎒 Mochila urbana": "🎒 Mochila urbana",
      "🛍️ Bolsa de compras": "🛍️ Saco de compras",
      "👜 Bolso grande": "👜 Bolsa grande",
      "🎒 Mochila portátil": "🎒 Mochila laptop",
      "🧥 Chaqueta": "🧥 Casaco",
      "🛍️ Bolsa de tela": "🛍️ Saco de tecido",
      "🧳 Maleta cabina": "🧳 Mala de cabine",
      "🎒 Mochila grande": "🎒 Mochila grande",
      "⛷️ Botas de esquí": "⛷️ Botas de ski",
      "🎒 Mochila trekking": "🎒 Mochila trekking",
      "🏋️ Bolsa de deporte": "🏋️ Bolsa de desporto",
      "🏕️ Equipo montaña": "🏕️ Equipamento de montanha",
      "🧳 Maleta mediana": "🧳 Mala média",
      "🏋️ Bolsa deporte XL": "🏋️ Bolsa desporto XL",
      "🎿 Bolsa de esquí": "🎿 Saco de ski",
      "🧳 Maleta delgada": "🧳 Mala fina",
      "🎿 Esquís": "🎿 Esquis",
      "🏄 Tabla estrecha": "🏄 Prancha estreita",
      "🧳 Maleta grande": "🧳 Mala grande",
      "🎿 Equipo esquí": "🎿 Equipamento de ski",
      "🛹 Skateboard": "🛹 Skateboard",
      "🧳 Maleta alta": "🧳 Mala alta",
      "🎸 Estuche instrumento": "🎸 Estojo de instrumento",
      "🏋️ Equipo deportivo": "🏋️ Equipamento desportivo",
      "🧳 Maleta XXL": "🧳 Mala XXL",
      "🏄 Tabla de surf": "🏄 Prancha de surf",
      "🚲 Bici plegable": "🚲 Bicicleta dobrável",
      "🎿 Bolsa de ski": "🎿 Saco de ski",
      "🏄 Tabla larga": "🏄 Prancha comprida",
      "🎻 Instrumento largo": "🎻 Instrumento comprido",
      "🧳 Maleta extra alta": "🧳 Mala extra alta",
      //Time Selector View
      "¿Qué deseas hacer?": "O que você deseja fazer?",
      "Selecciona una opción para continuar": "Selecione uma opção para continuar",
      "ALQUILAR TAQUILLA": "ALUGAR ARMÁRIO",
      "Alquila una nueva taquilla por tiempo": "Alugue um novo armário por tempo",
      "ABRIR TAQUILLA ALQUILADA": "ABRIR ARMÁRIO ALUGADO",
      "Accede a tu taquilla con tus credenciales": "Acesse seu armário com suas credenciais",
      "¿Cómo funciona?": "Como funciona?",
      "Reserva tu taquilla": "Reserve seu armário",
      "Elige tamaño y taquilla disponible.": "Escolha o tamanho e o armário disponível.",
      "Selecciona el tiempo": "Selecione o tempo",
      "Elige la duración del alquiler.": "Escolha a duração do aluguel.",
      "Recibes tus credenciales": "Receba suas credenciais",
      "Te enviamos un email con tu código de acceso.": "Enviamos um e-mail com seu código de acesso.",
      "Abre tu taquilla": "Abra seu armário",
      "Usa \"Abrir taquilla alquilada\" con tu teléfono y código.": "Use \"Abrir armário alugado\" com seu telefone e código.",
      "Amplía el tiempo": "Amplie o tempo",
      "Desde la pantalla de tu taquilla abierta puedes comprar más tiempo.": "Na tela do seu armário aberto você pode comprar mais tempo.",
      //Scan QR View
      "ESCANEA EL CÓDIGO QR": "DIGITALIZE O CÓDIGO QR",
      "Para iniciar el proceso de reserva, escanea el código QR que encontrarás en la zona de taquillas con la cámara de tu teléfono.": "Para iniciar o processo de reserva, digitalize o código QR que encontrará na área dos armários com a câmera do seu telefone.",
      //Rental Flow
      "Precio": "Preço",
      "Sin precio": "Sem preço",
      "Tipo de taquilla": "Tipo de armário",
      "por": "por",
      "Datos": "Dados",
      "Tiempo restante para completar la reserva": "Tempo restante para completar a reserva",
      "Tiempo agotado": "Tempo esgotado",
      "¿Salir de la reserva?": "Sair da reserva?",
      "El tiempo para completar tu reserva ha expirado. La pre-reserva se liberará automáticamente.": "O tempo para completar a sua reserva expirou. A pré-reserva será libertada automaticamente.",
      "Si sales ahora perderás la pre-reserva de taquillas. La selección se liberará automáticamente.": "Se sair agora perderá a pré-reserva dos armários. A seleção será libertada automaticamente.",
      "Continuar reserva": "Continuar reserva",
      "Salir": "Sair",
      "Introduce tu nombre": "Insira o seu nome",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "Lamentamos, mas não podemos manter a reserva do seu armário. Por favor reinicie o processo e conclua a compra dentro do tempo estipulado.",
      "¿Cancelar la compra?": "Cancelar a compra?",
      "Continuar con el pago": "Continuar com o pagamento",
      "Tiempo para confirmar el pago": "Tempo para confirmar o pagamento",
      "Importe Original": "Valor original",
      "Total": "Total",
      "¿Necesitas cambiar algo?": "Precisa de mudar alguma coisa?",
      "Cambiar datos": "Alterar dados",
      "Cancelar": "Cancelar",
      "El PIN se enviará al email el día de inicio de tu reserva": "O PIN será enviado para o seu email no dia de início da sua reserva",
      "El PIN se ha enviado a tu email": "O PIN foi enviado para o seu email",
      "AUTH": "AUTH",
      "FECHA": "DATA",
      "ACCESO A LOCAL": "ACESSO AO LOCAL",
      "Código": "Código",
      "INSTRUCCIONES DE USO:": "INSTRUÇÕES DE USO:"
    }
  },
  de: {
    translation: {
      //Generales
      "Confirmar": "Bestätigen",
      //Menu
      "Log in": "Anmelden",
      "Exit": "Ausgang",
      "TAQUILLA": "SCHLIEßFACH",
      "RESUMEN": "ZUSAMMENFASSUNG",
      "Mapa": "Karte",
      //Step Bar
      "Zona": "Zone",
      "Taquilla": "Schließfach",
      "Pago": "Bezahlung",
      "Email": "E-Mail",
      //Home View
      "PARECE QUE ALGO HA FALLADO": "IT SEEMS SOMETHING HAS FAILED",
      "VUELVE A ESCANEAR EL QR": "SCAN THE QR AGAIN",
      //Zone Selector View
      "SELECCIONA LA ZONA DE TAQUILLAS": "WÄHLE DIE SCHLIESSFACHZONE AUS",
      "BIENVENIDO A": "WILLKOMMEN BEI",
      "CONSULTA EL MAPA DEL PARQUE": "SIEHE DEN PARKPLAN",
      "ZONA ": "ZONE ",
      //Locker Selector View
      "SELECCIONA EL TIPO DE TAQUILLA": "WÄHLE DEN SCHLIESSFACHTYP AUS",
      "PARQUE": "PARK",
      "ZONA SELECCIONADA": "AUSGEWÄHLTE ZONE",
      "Taquilla": "Schließfach",
      "BÁSICA": "STANDARD",
      "BÁSICA CARGA": "STANDARD MIT LADEGERÄT",
      "BÁSICA XL": "STANDARD XL",
      "BÁSICA CARGA XL": "STANDARD MIT LADEGERÄT XL",
      "GRANDE": "GROSS",
      "GRANDE CARGA": "GROSS MIT LADEGERÄT",
      "GRANDE XL": "GROSS XL",
      "GRANDE CARGA XL": "GROSS MIT LADEGERÄT XL",
      "SKI": "SKI",
      "SKI CARGA": "SKI MIT LADEGERÄT",
      "SKI XL": "SKI XL",
      "SKI CARGA XL": "SKI MIT LADEGERÄT XL",
      "TAQUILLAS AGOTADAS": "AUSVERKAUFTE SCHLIESSFÄCHER",
      "Haz click aquí para volver a selección de zonas": "Klicken Sie hier, um zur Zonenauswahl zurückzukehren",
      //Accessibility View
      "¿NECESITAS UNA TAQUILLA ADAPTADA?": "BRAUCHEN SIE EIN ANGEPASSTES SCHLIESSFACH?",
      "Tienes la opción de seleccionar una taquilla de altura adaptada para tu confort.": "Sie haben die Möglichkeit, ein höhenangepasstes Schließfach für Ihren Komfort auszuwählen.",
      "NO": "NEIN",
      "SI": "JA",
      //Payment View
      "CONFIRMA TU COMPRA": "BESTÄTIGEN SIE IHREN KAUF",
      "Taquilla reservada durante": "Schließfach reserviert für",
      "PARQUE": "PARK",
      "ZONA": "ZONE",
      "ACCESIBLE": "ZUGÄNGLICH",
      "RESERVA": "RESERVIERUNG",
      "TIPO DE TAQUILLA": "SCHLIESSFACHTYP",
      "HASTA FINALIZAR EL DÍA": "BIS ZUM ENDE DES TAGES",
      "IVA": "MWST",
      "IMPORTE BASE": "GRUNDBETRAG",
      "IMPORTE IVA": "MWST-BETRAG",
      "TOTAL": "GESAMT",
      "Tiempo de reserva agotado": "Reservierungszeit abgelaufen",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo, otros usuarios deben poder acceder a ella. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "Es tut uns leid, aber wir können Ihr Schließfach nicht länger reservieren, andere Benutzer müssen darauf zugreifen können. Starten Sie den Prozess erneut und schließen Sie den Kauf innerhalb der vorgegebenen Zeit ab.",
      "Volver al inicio": "Zurück zum Anfang",
      "¿Seguro que quieres salir?": "Bist du sicher, dass du verlassen möchtest?",
      "Si abandonas ahora, tu taquilla reservada quedará libre y otro usuario podrá alquilarla.": "Wenn du jetzt verlässt, wird dein reserviertes Schließfach freigegeben und ein anderer Benutzer kann es mieten.",
      "Continuar con el alquiler": "Mit der Miete fortfahren",
      "Cancelar y salir": "Abbrechen und verlassen",
      "¿Volver a editar tus datos?": "Ihre Daten bearbeiten?",
      "Tu taquilla permanecerá reservada mientras completas el formulario.": "Ihr Schließfach bleibt reserviert, während Sie das Formular ausfüllen.",
      "Quedarme aquí": "Hier bleiben",
      "PAGAR": "BEZAHLEN",
      "RESERVAR": "RESERVIEREN",
      //Payment Error View
      "ERROR": "FEHLER",
      "No se ha podido realizar la compra. Vuelve a intentarlo más tarde.": "Der Kauf konnte nicht durchgeführt werden. Versuchen Sie es später erneut.",
      "VOLVER": "ZURÜCK",
      "AL INICIO": "ZUM ANFANG",
      //Phone View
      "¡TU TAQUILLA HA SIDO RESERVADA!": "DEIN SCHLIESSFACH WURDE RESERVIERT!",
      "FACILITANOS TUS DATOS DE RESPALDO": "GIB UNS DEINE BACKUP-DATEN",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin de esta en caso de que lo pierdas. Al email te llegará la confirmación de tu reserva.": "Dein Telefon wird mit dem reservierten Schließfach verknüpft, um die PIN bei Verlust wiederherstellen zu können. Die Bestätigung deiner Reservierung wird per E-Mail gesendet.",
      "TELÉFONO*": "TELEFONNUMMER*",
      "EMAIL*": "E-MAIL*",
      "Acepto ceder mi correo electrónico para recibir la confirmación de mi reserva.": "Ich stimme zu, meine E-Mail weiterzugeben, um die Bestätigung meiner Reservierung zu erhalten.",
      "Acepto suscribirme al boletín informativo de VACWAY para recibir contenido y notificaciones comerciales.": "Ich stimme zu, den Newsletter von VACWAY zu abonnieren, um kommerzielle Inhalte und Benachrichtigungen zu erhalten.",
      "CONTINUAR": "WEITER",
      "*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.": "*Die gesammelten persönlichen Daten werden in keinem Fall verwendet, um kommerzielle Mitteilungen jeglicher Art anzubieten, wenn der Kunde sich nicht für den Newsletter anmeldet.",
      //Ticket View
      "¡GRACIAS POR RESERVAR TU TAQUILLA!": "DANKE, DASS DU DEIN SCHLIESSFACH RESERVIERT HAST!",
      "Sigue las instrucciones que encontrarás a continuación o en tu email.": "Folge den Anweisungen unten oder in deiner E-Mail.",
      "TICKET": "TICKET",
      "Nº TAQUILLA": "SCHLIESSFACHNR.",
      "PIN": "PIN",
      "ZONA": "ZONE",
      "TIPO": "TYP",
      "UBICACIÓN": "STANDORT",
      "FACTURA": "RECHNUNG",
      "*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva.": "*Wenn du die PIN physisch erhalten möchtest, um sie während deines Aufenthalts im Park mitzunehmen, kontaktiere die Verantwortlichen des Schließfachbereichs und zeige ihnen deine Reservierungs-E-Mail.",
      "Proceso completado, taquilla reservada.": "Vorgang abgeschlossen, Schließfach reserviert.",
      "Alquilar otra taquilla": "Ein weiteres Schließfach mieten",
      "DESCARGAR TICKET": "TICKET HERUNTERLADEN",
      "INSTRUCCIONES": "ANLEITUNGEN",
      "PASO 1": "SCHRITT 1",
      "LOCALIZA TU TAQUILLA": "FINDE DEIN SCHLIESSFACH",
      "PASO 2": "SCHRITT 2",
      "TOCA EL TECLADO": "BERÜHRE DIE TASTATUR",
      "PASO 3": "SCHRITT 3",
      "INTRODUCE TU PIN": "GIB DEINE PIN EIN",
      "PASO 4": "SCHRITT 4",
      "ABRE LAS VECES QUE QUIERAS": "ÖFFNE SO OFT DU WILLST",
      "ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS": "ÖFFNE 1 MAL UM DEINE SACHEN ZU VERSTAUEN, NACHDEM DU GESCHLOSSEN HAST, HAST DU NOCH 1 ÖFFNUNG UM SIE HERAUSZUNEHMEN",
      //Ticket in Pdf (Ticket View)
      "Más información y garantía en www.vacway.com": "Mehr Informationen und Garantie unter www.vacway.com",
      "Factura Simplificada": "Vereinfachte Rechnung",
      "INFORMACIÓN DE TU LOCKER:": "INFORMATIONEN ZU DEINEM SCHLIESSFACH:",
      "Producto": "Produkt",
      "UNIDADES": "Einheiten",
      "Fecha y Hora": "Datum und Uhrzeit",
      "Reserva": "Rental",
      //LockerSelectorBaqueiraView
      "2 Equipos de esquí": "2 Skiausrüstung",
      "3 Equipos de esquí": "3 Skiausrüstung",
      "4 Equipos de esquí": "4 Skiausrüstung",
      "Selecciona...": "Wählen...",
      "Taquillas": "Schließfächer",
      "Atrás": "Zurück",
      "Continuar": "Weiter",
      "Fecha de Inicio": "Startdatum",
      "Fecha de Fin": "Enddatum",
      "LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.": "LEIDER SIND DIESE DATEN NICHT VERFÜGBAR. VERSUCHEN SIE ANDERE DATEN ODER EINE ANDERE ART VON SCHLIESSFACH.",
      "ZONA": "ZONE",
      "TIPO": "TYP",
      "CANTIDAD": "ANZAHL",
      "FECHAS": "DATEN",
      "Selecciona el tipo de taquilla": "Wählen Sie den Schliessfach-Typ",
      "Selecciona la cantidad": "Wählen Sie die Anzahl",
      "Selecciona las fechas": "Wählen Sie die Daten",
      "REVISA Y CONFIRMA": "ÜBERPRÜFEN UND BESTÄTIGEN",
      "El día actual no está disponible para selección después de las 18:00 hora local.": "Der aktuelle Tag ist nach 18:00 Uhr Ortszeit nicht mehr zur Auswahl verfügbar.",
      "El alquiler online está limitado a 14 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es": "Die Online-Miete ist auf 14 aufeinanderfolgende Tage begrenzt. Für Langzeitreservierungen wenden Sie sich bitte an das Personal des Baqueira Store oder kontaktieren Sie uns per E-Mail unter skiservice@baqueira.es.",
      "Zona": "Zone",
      "Tipo": "Typ",
      "Cantidad": "Menge",
      "Fechas": "Daten",
      "Importe": "Betrag",
      "taquilla": "Schließfach",
      "taquillas": "Schließfächer",
      "Inicio": "Beginn",
      "Fin": "Ende",
      "DD/MM/YYYY": "TT/MM/JJJJ",
      "Descuento aplicado": "Rabatt angewendet: {{discount}}% (ab {{days}} Tagen)",
      "Lun": "Mo",
      "Mar": "Di",
      "Mie": "Mi",
      "Jue": "Do",
      "Vie": "Fr",
      "Sab": "Sa",
      "Dom": "So",
      //PhoneBaqueiraView
      "NOMBRE COMPLETO*": "VOLLSTÄNDIGER NAME*",
      "Confirmo que he leído y acepto los términos y condiciones de uso del servicio.": "Ich bestätige, dass ich die Nutzungsbedingungen des Dienstes gelesen und akzeptiert habe.",
      "Leer términos y condiciones.": "Allgemeine Geschäftsbedingungen lesen.",
      //TicketBaqueiraView
      "Disponible en tu email que se enviará el día de inicio de tu reserva": "Verfügbar in Ihrer E-Mail, die am Startdatum Ihrer Reservierung gesendet wird",
      "FECHA COMPRA": "KAUFDATUM",
      //PaymentBaqueiraView
      "Te hemos aplicado un descuento en el precio, solo vas a pagar 5 días de tu reserva!": "Wir haben einen Rabatt auf den Preis angewendet; Sie zahlen nur für 5 Tage Ihrer Reservierung!",
      "IMPORTE ORIGINAL": "ORIGINALBETRAG",
      "Lo sentimos, pero la venta no está disponible entre las 23:00h y la 01:00h, vuelva fuera de este horario.": "Es tut uns leid, aber der Verkauf ist zwischen 23:00 Uhr und 01:00 Uhr nicht verfügbar, bitte kommen Sie außerhalb dieses Zeitraums zurück.",
      "Fuera de horario": "Außerhalb der Öffnungszeiten",
      //PRERENTAL
      " por ": " ",
      "RESERVA DE TAQUILLAS": "SPINDSRESERVIERUNG",
      "Cantidad de taquillas": "Anzahl der Schließfächer",
      "Selecciona cuántas taquillas necesitas": "Wählen Sie, wie viele Schließfächer Sie benötigen",
      "taquillas seleccionadas": "ausgewählte Schließfächer",
      "taquilla seleccionada": "ausgewähltes Schließfach",
      "RESERVA DE TAQUILLA": "SPINDSRESERVIERUNG",
      "Nombre Completo*": "Vollständiger Name*",
      "Email*": "E-Mail*",
      "Teléfono*": "Telefon*",
      "Confirmo que he leído y acepto los": "Ich bestätige, dass ich die gelesen und akzeptiert habe",
      "términos y condiciones": "Allgemeinen Geschäftsbedingungen",
      "CONFIRMA TU COMPRA": "BESTÄTIGEN SIE IHREN KAUF",
      "Tiempo para confirmar": "Zeit zur Bestätigung",
      "Revisa los datos de tu reserva": "Überprüfen Sie Ihre Buchungsdaten",
      "Zona:": "Bereich:",
      "Inicio:": "Beginn:",
      "Nombre": "Name",
      "Taquilla": "Schließfach",
      "Fin": "Ende",
      "Cantidad": "Menge",
      "Hora Límite": "Frist",
      "Teléfono": "Telefon",
      "Confirma los importes": "Beträge bestätigen",
      "Base": "Zwischensumme",
      "Pagar": "Bezahlen",
      "IVA": "MwSt",
      "Revisa los datos antes de confirmar el pago": "Überprüfen Sie Ihre Daten, bevor Sie die Zahlung bestätigen",
      "¿Necesitas hacer algún cambio?": "Müssen Sie Änderungen vornehmen?",
      "Editar mis datos": "Meine Daten bearbeiten",
      "Cambiar taquilla": "Schließfach wechseln",
      "Cancelar reserva": "Reservierung stornieren",
      "Resumen de reserva": "Buchungsübersicht",
      "Código de reserva": "Buchungscode",
      "Información de taquilla": "Informationen zum Schließfach",
      "Instrucciones": "Anweisungen",
      "DATOS DE RESPALDO": "SICHERUNGSDATEN",
      "Reservar": "Jetzt buchen",
      "Rellena los datos para ver disponibilidad": "Füllen Sie die Daten aus, um die Verfügbarkeit zu prüfen",
      "Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin": "Ihr Telefon wird mit dem reservierten Schließfach verknüpft, damit Sie die PIN wiederherstellen können",
      "Confirmar Email*": "E-Mail bestätigen*",
      "Repite tu email": "E-Mail wiederholen",
      "Los emails no coinciden": "Die E-Mail-Adressen stimmen nicht überein",
      "Tiempo para completar": "Zeit zum Ausfüllen",
      "Introduce tu email": "Gib deine E-Mail-Adresse ein",
      "Introduce tu teléfono": "Gib deine Telefonnummer ein",
      "Documento de Identidad*": "Ausweisdokument*",
      "DNI / NIE / Pasaporte": "Personalausweis / Reisepass",
      //Locker Info Modal
      "Volver": "Zurück",
      "¿Qué cabe en esta taquilla?": "Was passt in dieses Schließfach?",
      "Ancho": "Breite",
      "Alto": "Höhe",
      "Fondo": "Tiefe",
      "Ver información": "Informationen anzeigen",
      "Artículos compactos y anchos": "Breite kompakte Gegenstände",
      "Artículos pequeños": "Kleine Gegenstände",
      "Mochila urbana grande": "Großer Stadtrucksack",
      "Mochila urbana": "Stadtrucksack",
      "Maleta de cabina y mochilas grandes": "Handgepäck und große Rucksäcke",
      "Mochilas grandes y deporte": "Große Rucksäcke und Sport",
      "Maleta mediana": "Mittelgroßer Koffer",
      "Equipaje alto y estrecho": "Hohes schmales Gepäck",
      "Maleta grande de facturación": "Großes Aufgabegepäck",
      "Maleta alta y deporte": "Hoher Koffer und Sport",
      "Equipaje extra grande": "Extragroßes Gepäck",
      "Perfecta para cascos de bici o moto, bolsos de mano anchos y artículos personales voluminosos.": "Perfekt für Fahrrad- oder Motorradhelme, breite Handtaschen und sperrige persönliche Gegenstände.",
      "Ideal para cascos de bicicleta, bolsos pequeños y artículos personales de bolsillo.": "Ideal für Fahrradhelme, kleine Taschen und Taschenartikel.",
      "Cabe una mochila de ciudad amplia, bolsa de la compra o bolso de hombro de gran tamaño.": "Fasst einen großen Stadtrucksack, eine Einkaufstasche oder eine große Umhängetasche.",
      "Perfecta para mochila de portátil, bolsa de tela o chaqueta doblada.": "Perfekt für einen Laptop-Rucksack, eine Tragetasche oder eine gefaltete Jacke.",
      "Admite mochilas de gran tamaño y maletas de cabina estándar (hasta 55 cm de alto, 40 cm de ancho).": "Fasst große Rucksäcke und Standard-Handgepäck (bis 55 cm hoch, 40 cm breit).",
      "Caben mochilas de trekking, bolsas de deporte y equipo de montaña.": "Fasst Wanderrucksäcke, Sporttaschen und Bergausrüstung.",
      "Perfecta para maletas medianas de cabina y bolsas de deporte de gran tamaño.": "Perfekt für mittelgroße Kabinenkoffer und große Sporttaschen.",
      "Indicada para maletas delgadas en posición vertical o bolsas de esquí estrechas.": "Geeignet für schmale aufrechte Koffer oder schmale Skitaschen.",
      "Para maletas grandes de facturación y equipos deportivos voluminosos.": "Für große Aufgabekoffer und sperrige Sportausrüstung.",
      "Para maletas altas y estrechas, bolsas de viaje largas o estuches de instrumentos.": "Für hohe schmale Koffer, lange Reisetaschen oder Instrumentenkoffer.",
      "Nuestra taquilla más grande. Admite maletas enormes, tablas de surf, bolsas de ski o bicicletas plegadas.": "Unser größtes Schließfach. Fasst riesige Koffer, Surfboards, Skitaschen oder gefaltete Fahrräder.",
      "Para equipos de gran formato: esquís, tablas largas, instrumentos o maletas extra altas.": "Für übergroße Ausrüstung: Ski, lange Boards, Instrumente oder extra hohe Koffer.",
      "🪖 Casco bici / moto": "🪖 Fahrrad/Motorradhelm",
      "👜 Bolso de mano": "👜 Handtasche",
      "📦 Artículos pequeños": "📦 Kleine Gegenstände",
      "🪖 Casco bicicleta": "🪖 Fahrradhelm",
      "👜 Bolso pequeño": "👜 Kleine Tasche",
      "🎒 Mochila mini": "🎒 Mini-Rucksack",
      "🎒 Mochila urbana": "🎒 Stadtrucksack",
      "🛍️ Bolsa de compras": "🛍️ Einkaufstasche",
      "👜 Bolso grande": "👜 Große Tasche",
      "🎒 Mochila portátil": "🎒 Laptop-Rucksack",
      "🧥 Chaqueta": "🧥 Jacke",
      "🛍️ Bolsa de tela": "🛍️ Tragetasche",
      "🧳 Maleta cabina": "🧳 Kabinenkoffer",
      "🎒 Mochila grande": "🎒 Großer Rucksack",
      "⛷️ Botas de esquí": "⛷️ Skistiefel",
      "🎒 Mochila trekking": "🎒 Trekking-Rucksack",
      "🏋️ Bolsa de deporte": "🏋️ Sporttasche",
      "🏕️ Equipo montaña": "🏕️ Bergausrüstung",
      "🧳 Maleta mediana": "🧳 Mittelgroßer Koffer",
      "🏋️ Bolsa deporte XL": "🏋️ Sporttasche XL",
      "🎿 Bolsa de esquí": "🎿 Skitasche",
      "🧳 Maleta delgada": "🧳 Schmaler Koffer",
      "🎿 Esquís": "🎿 Skier",
      "🏄 Tabla estrecha": "🏄 Schmales Board",
      "🧳 Maleta grande": "🧳 Großer Koffer",
      "🎿 Equipo esquí": "🎿 Skiausrüstung",
      "🛹 Skateboard": "🛹 Skateboard",
      "🧳 Maleta alta": "🧳 Hoher Koffer",
      "🎸 Estuche instrumento": "🎸 Instrumentenkoffer",
      "🏋️ Equipo deportivo": "🏋️ Sportausrüstung",
      "🧳 Maleta XXL": "🧳 XXL-Koffer",
      "🏄 Tabla de surf": "🏄 Surfboard",
      "🚲 Bici plegable": "🚲 Faltrad",
      "🎿 Bolsa de ski": "🎿 Skitasche",
      "🏄 Tabla larga": "🏄 Longboard",
      "🎻 Instrumento largo": "🎻 Langes Instrument",
      "🧳 Maleta extra alta": "🧳 Extra hoher Koffer",
      //Time Selector View
      "¿Qué deseas hacer?": "Was möchten Sie tun?",
      "Selecciona una opción para continuar": "Wählen Sie eine Option, um fortzufahren",
      "ALQUILAR TAQUILLA": "SCHLIESSFACH MIETEN",
      "Alquila una nueva taquilla por tiempo": "Mieten Sie ein neues Schließfach zeitbasiert",
      "ABRIR TAQUILLA ALQUILADA": "GEMIETETES SCHLIESSFACH ÖFFNEN",
      "Accede a tu taquilla con tus credenciales": "Greifen Sie mit Ihren Zugangsdaten auf Ihr Schließfach zu",
      "¿Cómo funciona?": "Wie funktioniert es?",
      "Reserva tu taquilla": "Reservieren Sie Ihr Schließfach",
      "Elige tamaño y taquilla disponible.": "Wählen Sie Größe und verfügbares Schließfach.",
      "Selecciona el tiempo": "Zeit auswählen",
      "Elige la duración del alquiler.": "Wählen Sie die Mietdauer.",
      "Recibes tus credenciales": "Erhalten Sie Ihre Zugangsdaten",
      "Te enviamos un email con tu código de acceso.": "Wir senden Ihnen eine E-Mail mit Ihrem Zugangscode.",
      "Abre tu taquilla": "Öffnen Sie Ihr Schließfach",
      "Usa \"Abrir taquilla alquilada\" con tu teléfono y código.": "Verwenden Sie \"Gemietetes Schließfach öffnen\" mit Ihrem Telefon und Code.",
      "Amplía el tiempo": "Zeit verlängern",
      "Desde la pantalla de tu taquilla abierta puedes comprar más tiempo.": "Vom Bildschirm Ihres geöffneten Schließfachs können Sie mehr Zeit kaufen.",
      //Scan QR View
      "ESCANEA EL CÓDIGO QR": "QR-CODE SCANNEN",
      "Para iniciar el proceso de reserva, escanea el código QR que encontrarás en la zona de taquillas con la cámara de tu teléfono.": "Um den Buchungsprozess zu starten, scannen Sie den QR-Code im Schließfachbereich mit Ihrer Telefonkamera.",
      //Rental Flow
      "Precio": "Preis",
      "Sin precio": "Kein Preis",
      "Tipo de taquilla": "Schließfachtyp",
      "por": "für",
      "Datos": "Daten",
      "Tiempo restante para completar la reserva": "Verbleibende Zeit zum Abschließen der Buchung",
      "Tiempo agotado": "Zeit abgelaufen",
      "¿Salir de la reserva?": "Buchung verlassen?",
      "El tiempo para completar tu reserva ha expirado. La pre-reserva se liberará automáticamente.": "Die Zeit zur Vervollständigung Ihrer Buchung ist abgelaufen. Die Vorreservierung wird automatisch freigegeben.",
      "Si sales ahora perderás la pre-reserva de taquillas. La selección se liberará automáticamente.": "Wenn Sie jetzt verlassen, verlieren Sie die Schließfach-Vorreservierung. Die Auswahl wird automatisch freigegeben.",
      "Continuar reserva": "Buchung fortsetzen",
      "Salir": "Verlassen",
      "Introduce tu nombre": "Geben Sie Ihren Namen ein",
      "Lo sentimos, pero no podemos reservar tu taquilla por más tiempo. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.": "Es tut uns leid, aber wir können Ihr Schließfach nicht länger reservieren. Bitte starten Sie den Prozess neu und schließen Sie den Kauf innerhalb der vorgegebenen Zeit ab.",
      "¿Cancelar la compra?": "Kauf abbrechen?",
      "Continuar con el pago": "Mit der Zahlung fortfahren",
      "Tiempo para confirmar el pago": "Zeit zur Zahlungsbestätigung",
      "Importe Original": "Originalbetrag",
      "Total": "Gesamt",
      "¿Necesitas cambiar algo?": "Müssen Sie etwas ändern?",
      "Cambiar datos": "Daten ändern",
      "Cancelar": "Abbrechen",
      "El PIN se enviará al email el día de inicio de tu reserva": "Die PIN wird am Startdatum Ihrer Buchung per E-Mail gesendet",
      "El PIN se ha enviado a tu email": "Die PIN wurde an Ihre E-Mail gesendet",
      "AUTH": "AUTH",
      "FECHA": "DATUM",
      "ACCESO A LOCAL": "ZUGANG ZUM LOKAL",
      "Código": "Code",
      "INSTRUCCIONES DE USO:": "GEBRAUCHSANWEISUNG:"
    }
  },
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "es",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
